<template>
  <v-container>
    <!-- Date Picker and Search Button -->
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-top
          class="d-md-flex"
          outlined
          :useBtnList="[
            'btnSearch' //check
          ]"
          @btnSearch="search()"
        >
          <template v-slot:body>
            <v-layout column>
              <v-row no-gutters class="center pa-2 pb-0">                
                <i-label :label="'Plan Date : '" class="pl-2"/>
                <v-col cols="12" md="2">
                   <DxDateBox                        
                        :value="selectedDate"
                        height="30px"
                        display-format="yyyy-MM-dd"
                        :acceptCustomValue="false"
                        @value-changed="e => {selectedDate = e.value && getStrFormat(e.value)}"
                    />
                </v-col>  
              </v-row>
            </v-layout>
          </template>
        </i-card-top>
      </v-col>
    </v-row>  
    <!-- Canvas Area -->
    <v-row no-gutters class="position-relative">
      <!-- Loading Indicator -->
      <!-- <v-container
        v-if="isLoading"
        class="loading-container"
        fill-height
      >
        <v-row justify="center" align="center" class="text-center">
          <v-col cols="12">
            <v-progress-circular
              indeterminate
              color="primary"
              size="50"
            ></v-progress-circular>
          </v-col>
          <v-col cols="12">
            <span class="loading-text">Loading...</span>
          </v-col>
        </v-row>
      </v-container> -->
      <!-- Nội dung chính -->
      <v-col cols="12" class="pa-0">
        <v-sheet style="overflow-x: auto; overflow-y: auto" > 
          <canvas ref="logoCanvas" width="1400px" height="0px"></canvas> 
          <canvas ref="ani" width="1400px" height="1000px">DOCK AND QUAY LAYOUT</canvas>
        </v-sheet>
      </v-col>  
    </v-row> 
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn, DxLookup, DxSelection, DxPager } from 'devextreme-vue/data-grid'
import iButton from '@/components/common/iButton'
import DxDateBox from 'devextreme-vue/date-box'
import themes from 'devextreme/ui/themes'
import ICardVertical from '@/components/common/iCardVertical.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import notify from 'devextreme/ui/notify' // message
import dayjs from 'dayjs'
import moment from 'moment'
import {getDateFormat, getCurrentDate } from '@/utils/common.js'

import {CalRotPosX, CalRotPosY, CalRotPosXY, CalcInDock, CZ } from '@/utils/common.js'
import { getCurDockEvent, 
         getMoveSch, 
         getBlkStock, 
         getEmpNo, 
         getShipEvent,
         getLayUpEvt,
         getNixShipList,
         getMatShipList,
         getConfirmInfo,
         getSummaryStatus,
         getAddObj,
         getShipList
         } from '@/api/view/pp/20/v20a4010.js'

export default {
  mixins: [baseview, BaseDataGrid],

  components: {
    ICardVertical,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxDateBox,
    DxLookup,
    DxSelection,
    DxPager,
    iButton
  },
  data() {
    return {
      canvas: null,
      context: null,  
      strStartDate: "",
      selectedDate: '',// new Date().toISOString().substr(0, 10),
      menu: false,
      PHI: 3.14159265,
      PHII: 314159,
      DATE_FORMAT: /^([0-9]{4}-[0-9]{2}-[0-9]{2})$/,

      SIZE_QUAY3: 870,
      SIZE_QUAY2: 195,
      SIZE_GAP: 20,
      SIZE_QUAY1: 720,
      SIZE_QUAY100: 482,
      SIZE_QUAY5: 480,
      SIZE_QUAY6: 600,
      zoom: 100,

      dock_top: [],
      dock_left: [],
      dock_bottom: [],
      dock_right: [],

      // Quay declaration
      Q1_Start_x: null, Q1_Start_y: null, Q1_Finish_x: null, Q1_Finish_y: null,
      Q2_Start_x: null, Q2_Start_y: null, Q2_Finish_x: null, Q2_Finish_y: null,
      Q3_Start_x: null, Q3_Start_y: null, Q3_Finish_x: null, Q3_Finish_y: null,
      Q4_Start_x: null, Q4_Start_y: null, Q4_Finish_x: null, Q4_Finish_y: null,

      M1_Start_x: null, M1_Start_y: null, M1_Finish_x: null, M1_Finish_y: null,
      M2_Start_x: null, M2_Start_y: null, M2_Finish_x: null, M2_Finish_y: null,

      D1_Start_x: null, D1_Start_y: null, D1_Finish_x: null, D1_Finish_y: null,
      D2_Start_x: null, D2_Start_y: null, D2_Finish_x: null, D2_Finish_y: null,

      Q5_Start_x: null, Q5_Start_y: null, Q5_Finish_x: null, Q5_Finish_y: null,
      Q6_Start_x: null, Q6_Start_y: null, Q6_Finish_x: null, Q6_Finish_y: null,

    //   ST_Start_x: 250 + 1450, ST_Start_y: 190 + 370, ST_Finish_x: 250 + 1450 + 340, ST_Finish_y: 190 + 370 + 300,
      ST_Start_x: 250 + 1450, ST_Start_y: 190 + 370, ST_Finish_x: 250 + 1450 + 340, ST_Finish_y: 190 + 370 + 300,

      Start_X: 5,
      Start_Y: 70,
      Finish_X: 1350,//1295
      Finish_Y: 895,//895

      Ship_body_x: [],
      Ship_body_y: [],
      Ship_pt_x: [],
      Ship_pt_y: [],

      iOP_Cnt: 0,
      isLoading: false
    };
  },
  computed: {
    // formattedDate() {
    //   return this.selectedDate;
    // }
  },
  created() {
  },
  mounted() {
    let toDay = new Date;
        toDay.setDate(toDay.getDate());
    this.selectedDate = getDateFormat(toDay);
    // console.log("mounted for date: ", this.selectedDate);
    this.initCanvas();
  },
  beforeDestroy() {
   
  },
  methods: {
     getStrFormat(date) {
      this.selectedDate = date
      return getDateFormat(date)
    },
    search() {
      this.initCanvas()
      // console.log("Searching for date: ", this.selectedDate);
    },
    initCanvas() {   
      // Lấy thẻ canvas và context
      this.canvas = this.$refs.ani;
      this.context = this.canvas.getContext("2d");
      // console.log("this.context: ", this.context);

      // Xóa canvas
      this.canvas.height = 900;
			this.canvas.width  = 1400;
      this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);

      // Gọi các hàm vẽ
      this.drawLogo();
      this.drawBorder();
      this.drawYard();
      this.ShowHeaderInfo();
      this.drawCurDockEvent();
      this.drawBlkStock();
      this.drawShipEvent();
      this.ShowShip();
      this.drawMovingSCH();
      this.drawMatShipInfo();
      this.drawLayUpInfo();
      this.drawAddObj();
    },
    validFormatStr(dateStr) {
      return /^\d{4}-\d{2}-\d{2}$/.test(dateStr);
    },
    drawLogo() {
      
      let logoTop = 0, logoLeft = 10;
      let logoWidth = 20;// độ dài cạnh tam giác đều
      let logoHeight = (logoWidth * 1.73) / 2;// Chiều cao tam giác đều

      let logoCanvas = this.$refs.logoCanvas;
      if (!logoCanvas) return;
      // Xóa nền      
      this.context.clearRect(0, 0, 300, 0);

      // Vẽ tam giác dưới cùng (xanh đậm)
      this.context.beginPath();
      this.context.moveTo(logoLeft + 0, logoTop + 2 * logoHeight);//E
      this.context.lineTo(logoLeft + 10, logoTop + logoHeight);//F
      this.context.lineTo(logoLeft + 20, logoTop + 2 * logoHeight);//D
      this.context.closePath();
      this.context.fillStyle = "#0b833c"; // Xanh đậm
      this.context.fill();

      // Vẽ tam giác giữa (xanh vừa)
      this.context.beginPath();
      this.context.moveTo(logoLeft + 0, logoTop + 0);//A
      this.context.lineTo(logoLeft + 20, logoTop + 2 * logoHeight);//D
      this.context.lineTo(logoLeft + 30, logoTop + logoHeight);//C
      this.context.closePath();
      this.context.fillStyle = "#12b041"; // Xanh vừa
      this.context.fill();

      // Vẽ tam giác trên cùng (xanh nhạt)
      this.context.beginPath();
      this.context.moveTo(logoLeft + 0, logoTop + 0);//A
      this.context.lineTo(logoLeft + 30, logoTop + logoHeight);//C
      this.context.lineTo(logoLeft + 20, logoTop + 0);//B
      this.context.closePath();
      this.context.fillStyle = "#38d52e"; // Xanh nhạt
      this.context.fill();

      // Vẽ chữ "HD"
      this.context.font = "bold 32px Arial";//Arial
      this.context.fillStyle = "#003B79"; // Màu xanh đậm
      this.context.fillText("HD", logoLeft + 35, logoTop + 30);
      
      // Vẽ chữ "HYUNDAI VIETNAM"
      this.context.font = "bold 12px Arial";//Arial
      this.context.fillStyle = "#003B79"; // Màu xanh đậm
      this.context.fillText("HYUNDAI VIETNAM", logoLeft + 85, logoTop + 18);

      // Vẽ chữ "SHIPBUILDING"
      this.context.font = "bold 12px Arial";//Arial
      this.context.fillStyle = "#003B79"; // Màu xanh đậm
      this.context.fillText("SHIPBUILDING", logoLeft + 85, logoTop + 30);

      // Vẽ chữ "DAILY HVS BLOCK PILED LIST"
      this.context.font = "bold 42px Times New Roman";//Arial
      this.context.fillStyle = "#003B79"; // Màu xanh đậm
      this.context.fillText("HVS DOCK & QUAY PLAN", logoLeft + 300, logoTop + 30);
    },
    drawBorder() {
      // console.log("Drawing border...");
      if (!this.context) return; // Kiểm tra xem context đã được khởi tạo chưa

        this.context.beginPath();
        this.context.strokeStyle = "black";
        this.context.lineWidth = 2;

        // Vẽ các đường viền
        this.context.moveTo(this.Start_X, this.Start_Y);
        this.context.lineTo(this.Start_X, this.Finish_Y);

        this.context.moveTo(this.Start_X, this.Start_Y);
        this.context.lineTo(this.Finish_X, this.Start_Y);

        this.context.moveTo(this.Start_X, this.Finish_Y);
        this.context.lineTo(this.Finish_X, this.Finish_Y);

        this.context.moveTo(this.Finish_X, this.Start_Y);
        this.context.lineTo(this.Finish_X, this.Finish_Y);

        this.context.stroke();
        this.context.closePath();
    },
    drawYard() {
      // console.log("Drawing yard...");
      let rad, top_gap, str;
      let i, j;
      let sx, sy, ex, ey;
      let m_sx, m_sy, m_ex, m_ey;
      let bo_x = [];
      let bo_y = [];     
      
      //context.save();
      //#1 QUAY DRAWING            
      sx = 658;
      sy = 0;
      ex = 150;
      ey = 0;
      rad = 0;          
      top_gap = 250;	
      
      this.Q1_Start_x  = Math.ceil(CalRotPosX(sx, sy, rad));
      this.Q1_Start_y  = Math.ceil(CalRotPosY(sx, sy, rad)) + top_gap;
      this.Q1_Finish_x = Math.ceil(CalRotPosX(ex, ey, rad));
      this.Q1_Finish_y = Math.ceil(CalRotPosY(ex, ey, rad)) + top_gap;
      
      this.context.beginPath();
      this.context.strokeStyle = "black";
      this.context.lineWidth   = 1;
      this.context.moveTo(CZ(this.Q1_Start_x),CZ(this.Q1_Start_y));
      this.context.lineTo(CZ(this.Q1_Finish_x),CZ(this.Q1_Finish_y));
          
      this.drawText("#1QB",CZ(this.Q1_Finish_x + 120),  CZ(this.Q1_Start_y), "m_fntQuay", "black", "0");
      this.drawText("#2QB",CZ(this.Q1_Finish_x + 120),  CZ(this.Q1_Start_y + 18), "m_fntQuay", "black", "0");  
      this.context.stroke();      			
      this.context.closePath();
      
      //rule lines drawing
      this.context.beginPath();
      this.context.strokeStyle = "grey";
      this.context.lineWidth   = 0.5;	
      
      for (i = Math.ceil(sx), j = 0; i > ex ; i -= 10 , j++){
        m_sx = Math.ceil(CalRotPosX(i, 0, rad) + 0.5);
        m_sy = Math.ceil(CalRotPosY(i, 0, rad) + 0.5) + top_gap;
        
        if ( j % 10 == 0 ){
        
          m_ex = Math.ceil(CalRotPosX(i, 7, rad) + 0.5) ;
          m_ey = Math.ceil(CalRotPosY(i, 7, rad) + 0.5) + top_gap;

          str = String(j * 10 );
          //this.drawText(str, CZ(m_ex - 24), CZ(m_sy - 15), "m_fntQuayDesc", "blue", "0");
          this.drawText(str, CZ(m_ex - 8), CZ(m_sy), "m_fntQuayDesc", "blue", "0");
        }
        else {        
          m_ex = Math.ceil(CalRotPosX(i, 4, rad)) + 1;
          m_ey = Math.ceil(CalRotPosY(i, 4, rad)) + top_gap;

        }
        this.context.moveTo(CZ(m_sx),CZ(m_sy));
        this.context.lineTo(CZ(m_ex),CZ(m_ey));	
      }
      this.context.stroke() ;
      this.context.closePath();
      
      this.context.beginPath();
      this.context.strokeStyle = "black";
      this.context.lineWidth   = 1;	
      this.context.moveTo(CZ(this.Q1_Start_x), CZ(this.Q1_Start_y));
      this.context.lineTo(CZ(this.Q1_Start_x), CZ(this.Start_Y));	
      this.context.stroke() ;
      this.context.closePath();
          
      //#2 QUAY DRAWING
      sx = 658;
      sy = 0;
      ex = 150;
      ey = 0;
      rad = 0;

      top_gap = 288;
  
      this.Q2_Start_x  = Math.ceil(CalRotPosX(sx, sy, rad));
      this.Q2_Start_y  = Math.ceil(CalRotPosY(sx, sy, rad)) + top_gap;
      this.Q2_Finish_x = Math.ceil(CalRotPosX(ex, ey, rad));
      this.Q2_Finish_y = Math.ceil(CalRotPosY(ex, ey, rad)) + top_gap;
  
      this.context.beginPath();
      this.context.strokeStyle = "black";
      this.context.lineWidth   = 1;		
      this.context.moveTo(CZ(this.Q2_Start_x), CZ(this.Q2_Start_y));
      this.context.lineTo(CZ(this.Q2_Finish_x),CZ(this.Q2_Finish_y));	
      this.context.stroke() ;
      this.drawText("#1QA",CZ(this.Q2_Start_x - 180), CZ(this.Q2_Start_y - 38), "m_fntQuay", "black", "0");
      this.drawText("#2QA",CZ(this.Q2_Start_x - 180), CZ(this.Q2_Start_y - 18), "m_fntQuay", "black", "0");
      this.context.closePath();
      
      //Extend Quay
      this.context.beginPath();
      this.context.strokeStyle = "black";
      this.context.lineWidth   = 1;
      
      this.context.moveTo(CZ(this.Q1_Finish_x), CZ(this.Q1_Finish_y));
      this.context.lineTo(CZ(this.Q2_Finish_x), CZ(this.Q2_Finish_y));

      this.context.moveTo(CZ(this.Q1_Finish_x),CZ(this.Q1_Finish_y + 17));
      this.context.lineTo(CZ(this.Q1_Finish_x - 42),CZ(this.Q1_Finish_y + 17));
  
      this.context.moveTo(CZ(this.Q2_Finish_x),CZ(this.Q2_Finish_y - 17));
      this.context.lineTo(CZ(this.Q2_Finish_x - 42),CZ(this.Q2_Finish_y - 17));
  
      this.context.moveTo(CZ(this.Q1_Finish_x - 42),CZ(this.Q1_Finish_y + 17));
      this.context.lineTo(CZ(this.Q1_Finish_x - 42),CZ(this.Q1_Finish_y + 13));
  
      this.context.moveTo(CZ(this.Q2_Finish_x - 42),CZ(this.Q2_Finish_y - 17));
      this.context.lineTo(CZ(this.Q2_Finish_x - 42),CZ(this.Q2_Finish_y - 13));
  
      this.context.moveTo(CZ(this.Q1_Finish_x - 42),CZ(this.Q1_Finish_y + 13));
      this.context.lineTo(CZ(this.Q1_Finish_x - 50),CZ(this.Q1_Finish_y + 13));
  
      this.context.moveTo(CZ(this.Q2_Finish_x - 42),CZ(this.Q2_Finish_y - 13));
      this.context.lineTo(CZ(this.Q2_Finish_x - 50),CZ(this.Q2_Finish_y - 13));
  
      this.context.moveTo(CZ(this.Q1_Finish_x - 50),CZ(this.Q1_Finish_y + 13));
      this.context.lineTo(CZ(this.Q2_Finish_x - 50),CZ(this.Q2_Finish_y - 13));
      this.context.stroke() ;
      this.context.closePath();
      
      //100M QUAY DRAWING
      this.M1_Start_x = this.Q2_Start_x;
      this.M1_Start_y = this.Q2_Start_y;
      
      ex = 100;
      ey = 0;
      rad = 90;
  
      this.M1_Finish_x = Math.ceil(CalRotPosX(ex, ey, rad));
      this.M1_Finish_y = Math.ceil(CalRotPosY(ex, ey, rad));
  
      this.M1_Finish_x = this.M1_Finish_x + this.Q2_Start_x;
      this.M1_Finish_y = this.M1_Finish_y + this.Q2_Start_y;
      
      this.context.beginPath();
      this.context.strokeStyle = "black";
      this.context.lineWidth   = 1;
      this.context.moveTo(CZ(this.M1_Start_x),CZ(this.M1_Start_y));
      this.context.lineTo(CZ(this.M1_Finish_x),CZ(this.M1_Finish_y));
      this.context.stroke() ;
      this.drawRotateText("100M QUAY", CZ(this.M1_Start_x + 12), CZ(this.M1_Start_y + 40), "m_fntQuay", "black", rad);
      this.drawRotateText("#3QA", CZ(this.M1_Start_x + 12), CZ(this.M1_Start_y + 340), "m_fntQuay", "black", rad);
      this.context.closePath();
      
      this.context.beginPath();
      this.context.strokeStyle = "grey";
      this.context.lineWidth   = 0.5;
          
      for (i = Math.ceil(ex), j = 0; i >= 0 ; i -= 10 , j++){
      
        m_sx = this.M1_Finish_x - Math.ceil(CalRotPosX(i, 0, rad) + 0.5);
        m_sy = this.M1_Finish_y - Math.ceil(CalRotPosY(i, 0, rad) + 0.5);
        
        if ( (j % 5 == 0) && j < 10){
        
          m_ex = this.M1_Finish_x - Math.ceil(CalRotPosX(i, 7, rad) + 0.5) ;
          m_ey = this.M1_Finish_y - Math.ceil(CalRotPosY(i, 7, rad) + 0.5) ;

          str = String(j * 10);
          this.drawRotateText(str, CZ(m_ex - 6), CZ(m_sy - 5) , "m_fntQuayDesc", "blue", rad);
            
        }
        else {
            
          m_ex = this.M1_Finish_x - Math.ceil(CalRotPosX(i, 4, rad) + 0.5) ;
          m_ey = this.M1_Finish_y - Math.ceil(CalRotPosY(i, 4, rad) + 0.5) ;
            
        }
        
        if(j < 10){
        
          this.context.moveTo(CZ(m_sx) + 2, CZ(m_sy) + 1);
          this.context.lineTo(CZ(m_ex) + 2, CZ(m_ey) + 1);
            
        }
      }
      this.context.stroke() ;
      this.context.closePath();
      
      //#1DOCK DRAWING	
      this.D1_Start_x  = this.M1_Finish_x + 8; //#1 dock gate
      this.D1_Finish_x = this.D1_Start_x + 266; 
      this.D1_Start_y  = this.M1_Finish_y;
      this.D1_Finish_y = this.D1_Start_y + 45 ;
      
      this.dock_top[1] 	= this.D1_Start_y;
      this.dock_left[1]	= this.D1_Start_x;
      this.dock_bottom[1]	= this.D1_Finish_y;
      this.dock_right[1]	= this.D1_Finish_x;
  
      this.context.beginPath() ;
      this.context.strokeStyle = "black";
      this.context.lineWidth   = 1
      
      this.context.rect(CZ(this.D1_Start_x) + 1, CZ(this.D1_Start_y), 266, 45);		
      this.context.rect(CZ(this.Q1_Start_x) + 1, CZ(this.D1_Start_y - 5), 8, 55);	
      
      str = "#1DOCK(260X45)";
      this.drawText(str, CZ(this.D1_Start_x + 60), CZ(this.D1_Finish_y + 10), "m_fntQuay", "black", "0");
      this.context.stroke() ;
      this.context.closePath() ;
      
      //#2Dock slop entrance
      m_sx = this.D1_Finish_x - 20; //40;
      m_sy = this.D1_Start_y ;
      m_ex = m_sx;
      m_ey = m_sy + 6; 
      
      bo_x[0] = m_sx;
      bo_y[0] = m_sy;

      m_sx = this.D1_Finish_x - 20;//40;
      m_sy = this.D1_Start_y + 6;
      m_ex = this.D1_Finish_x - 6;
      m_ey = m_sy; 
      bo_x[1] = m_sx;
      bo_y[1] = m_sy;
      
      m_sx = this.D1_Finish_x - 6;
      m_sy = this.D1_Start_y + 6;
      m_ex = this.D1_Finish_x - 6; 
      m_ey = this.D1_Finish_y - 1; 
      bo_x[2] = m_sx;
      bo_y[2] = m_sy;
      
      m_sx = this.D1_Finish_x - 6;
      m_sy = this.D1_Finish_y - 1; 
      m_ex = this.D1_Finish_x - 1;
      m_ey = this.D1_Finish_y - 1; 
      bo_x[3] = m_sx;
      bo_y[3] = m_sy;
  
      m_sx = this.D1_Finish_x - 1;
      m_sy = this.D1_Finish_y - 1; 
      m_ex = this.D1_Finish_x - 1;
      m_ey = this.D1_Start_y; 
      
      bo_x[4] = m_sx;
      bo_y[4] = m_sy;

      m_sx = this.D1_Finish_x - 1;
      m_sy = this.D1_Start_y; 
      m_ex = this.D1_Finish_x - 20;//40;
      m_ey = this.D1_Start_y - 1; 
      bo_x[5] = m_sx;
      bo_y[5] = m_sy;

      bo_x[6] = bo_x[0];
      bo_y[6] = bo_y[0];      
  
      //Polyline(bo, 7);
      
      this.context.beginPath() ;
      this.context.strokeStyle = "black";
      this.context.lineWidth   = 1
      this.context.moveTo(bo_x[0], bo_y[0]);
      this.context.lineTo(bo_x[1], bo_y[1]);
      this.context.lineTo(bo_x[2], bo_y[2]);
      this.context.lineTo(bo_x[3], bo_y[3]);
      this.context.lineTo(bo_x[4], bo_y[4]);
      this.context.lineTo(bo_x[5], bo_y[5]);
      this.context.lineTo(bo_x[6], bo_y[6]);
      this.context.stroke() ;
      this.context.closePath() ;
      
      this.context.beginPath() ;
      this.context.strokeStyle = "grey";
      this.context.lineWidth   = 0.5;
      
      for (i = 0, j = 0; i <= 260 ; i += 10 , j++){
      
        m_sx = this.D1_Start_x + j * 10;
        m_sy = this.D1_Finish_y;
        
        if ( (j % 5 == 0) && j != 0){
        
          m_ex = this.D1_Start_x + j * 10;
          m_ey = this.D1_Finish_y + 5;

          str = String(j * 10 );
          this.drawText(str,  CZ(m_ex - 10), CZ(m_sy + 2) , "m_fntQuayDesc", "blue", "0");
        }
        else {
        
          m_ex = this.D1_Start_x + j * 10;
          m_ey = this.D1_Finish_y + 2;

        }
        //if(j < 10){
          this.context.moveTo(CZ(m_sx),CZ(m_sy) + 1);
          this.context.lineTo(CZ(m_ex),CZ(m_ey) + 2);
            
        //}
      }
      this.context.stroke() ;
      this.context.closePath() ;
      
      m_sx = this.D1_Start_x - 8;
      m_sy = this.D1_Finish_y;
      m_ex = this.D1_Start_x - 8;
      m_ey = this.D1_Finish_y + 80;
      
      this.M2_Start_x = this.D1_Start_x - 8;
      this.M2_Start_y = this.D1_Finish_y;
  
      ex = 80;
      ey = 0;
      rad = 90;
  
      this.M2_Finish_x = Math.ceil(CalRotPosX(ex, ey, rad));
      this.M2_Finish_y = Math.ceil(CalRotPosY(ex, ey, rad));
  
      this.M2_Finish_x = this.M2_Finish_x + this.D1_Start_x;
      this.M2_Finish_y = this.M2_Finish_y + this.D1_Finish_y;
      
      this.context.beginPath() ;
      this.context.strokeStyle = "black";
      this.context.lineWidth   = 1;
      this.context.moveTo(CZ(m_sx),CZ(m_sy));
      this.context.lineTo(CZ(m_ex),CZ(m_ey));
      this.context.stroke() ;
      this.context.closePath() ;
      
      //#2 DOCK DRAWING
      this.D2_Start_x =this. D1_Start_x; //10 dock gate
      this.D2_Finish_x = this.D1_Start_x + 386;
      this.D2_Start_y =  m_ey;
      this.D2_Finish_y = this.D2_Start_y + 65;
      
      this.dock_top[2] 	= this.D2_Start_y;
      this.dock_left[2]	= this.D2_Start_x;
      this.dock_bottom[2]	= this.D2_Finish_y;
      this.dock_right[2]	= this.D2_Finish_x;

      this.context.beginPath() ;
      this.context.strokeStyle = "black";
      this.context.lineWidth   = 1
      this.context.rect(CZ(this.D2_Start_x) + 1, CZ(this.D2_Start_y), 386, 65);		
      this.context.rect(CZ(this.Q1_Start_x) + 1, CZ(this.D2_Start_y), 8, 70);	
      this.context.stroke() ;
      str = "#2DOCK(380X65)";
      this.drawText(str, CZ(this.D2_Start_x + 60), CZ(this.D2_Finish_y + 15), "m_fntQuay", "black", "0");
      this.context.closePath() ;
      
      //Dock Pump Room drawing
      bo_x[0] = this.D2_Start_x - 7;
      bo_y[0] = this.D2_Start_y - 1;
  
      bo_x[1] = bo_x[0]	;
      bo_y[1] = bo_y[0] - 34;
  
      bo_x[2] = bo_x[1] + 20;
      bo_y[2] = bo_y[1];
  
      bo_x[3] = bo_x[2] + 10;
      bo_y[3] = bo_y[2] + 10;
  
      bo_x[4] = bo_x[3] + 20;
      bo_y[4] = bo_y[3];
  
      bo_x[5] = bo_x[4];
      bo_y[5] = bo_y[4] + 24;
  
      bo_x[6] = bo_x[0];
      bo_y[6] = bo_y[0];

      this.context.beginPath();
      this.context.fillStyle = "cyan";
      this.context.moveTo(bo_x[0], bo_y[0]);
      this.context.lineTo(bo_x[1], bo_y[1]);
      this.context.lineTo(bo_x[2], bo_y[2]);
      this.context.lineTo(bo_x[3], bo_y[3]);
      this.context.lineTo(bo_x[4], bo_y[4]);
      this.context.lineTo(bo_x[5], bo_y[5]);
      this.context.lineTo(bo_x[6], bo_y[6]);
      this.context.stroke();
      this.context.fill();
      this.context.closePath() ;      
      
      //#2Dock slop entrance
      m_sx = this.D2_Finish_x - 20;
      m_sy = this.D2_Start_y + 1;
      m_ex = m_sx;
      m_ey = m_sy + 6; 
      bo_x[0] = m_sx;
      bo_y[0] = m_sy;
      
      m_sx = this.D2_Finish_x - 20;
      m_sy = this.D2_Start_y + 6;
      m_ex = this.D2_Finish_x - 10;
      m_ey = m_sy; 
      bo_x[1] = m_sx;
      bo_y[1] = m_sy;

      m_sx = this.D2_Finish_x - 6;
      m_sy = this.D2_Start_y + 6;
      m_ex = this.D2_Finish_x - 6;
      m_ey = this.D2_Finish_y - 1; 
      bo_x[2] = m_sx;
      bo_y[2] = m_sy;

      m_sx = this.D2_Finish_x - 6;
      m_sy = this.D2_Finish_y - 1; 
      m_ex = this.D2_Finish_x - 1;
      m_ey = this.D2_Finish_y - 1; 
      bo_x[3] = m_sx;
      bo_y[3] = m_sy;
  
      m_sx = this.D2_Finish_x - 1;
      m_sy = this.D2_Finish_y - 1; 
      m_ex = this.D2_Finish_x - 1;
      m_ey = this.D2_Start_y; 
      bo_x[4] = m_sx;
      bo_y[4] = m_sy;
      
      m_sx = this.D2_Finish_x - 1;
      m_sy = this.D2_Start_y; 
      m_ex = this.D2_Finish_x - 20;
      m_ey = this.D2_Start_y - 1; 
      bo_x[5] = m_sx;
      bo_y[5] = m_sy;
  
      bo_x[6] = bo_x[0];
      bo_y[6] = bo_y[0];
      
      this.context.beginPath() ;
      this.context.moveTo(bo_x[0], bo_y[0]);
      this.context.lineTo(bo_x[1], bo_y[1]);
      this.context.lineTo(bo_x[2], bo_y[2]);
      this.context.lineTo(bo_x[3], bo_y[3]);
      this.context.lineTo(bo_x[4], bo_y[4]);
      this.context.lineTo(bo_x[5], bo_y[5]);
      this.context.lineTo(bo_x[6], bo_y[6]);
      this.context.stroke();
      this.context.closePath() ;
      
      this.context.beginPath() ;
      this.context.strokeStyle = "grey";
      this.context.lineWidth   = 0.5;
      
      for (i = 0, j = 0; i <= 380 ; i += 10 , j++){
        m_sx = this.D2_Start_x + j * 10;
        m_sy = this.D2_Finish_y;
        if ( (j % 5 == 0) && j != 0){
        
          m_ex = this.D2_Start_x + j * 10;
          m_ey = this.D2_Finish_y + 5;
          
          str = String(j * 10 );
          this.drawText(str, CZ(m_ex - 10), CZ(m_sy + 2) , "m_fntQuayDesc", "blue" , "0");
            
        }
        else {
          m_ex = this.D2_Start_x + j * 10;
          m_ey = this.D2_Finish_y + 2;

        }
          this.context.moveTo(CZ(m_sx),CZ(m_sy) + 1);
          this.context.lineTo(CZ(m_ex),CZ(m_ey) + 2);
      }
      this.context.stroke() ;
      this.context.closePath() ;
      
      //#3 QUAY DRAWING
      this.Q3_Start_x = this.D2_Start_x - 8;
      this.Q3_Start_y = this.D2_Finish_y;

      ex = 250 + 15;
      ey = 0;
      rad = 90;
      
      this.Q3_Finish_x = Math.ceil(CalRotPosX(ex, ey, rad));
      this.Q3_Finish_y = Math.ceil(CalRotPosY(ex, ey, rad));
  
      this.Q3_Finish_x = this.Q3_Finish_x + this.Q3_Start_x;
      this.Q3_Finish_y = this.Q3_Finish_y + this.Q3_Start_y;
      
      this.context.beginPath() ;
      this.context.strokeStyle = "black";
      this.context.lineWidth   = 1;
      this.context.moveTo(CZ(this.Q3_Start_x),CZ(this.Q3_Start_y));
      this.context.lineTo(CZ(this.Q3_Finish_x),CZ(this.Q3_Finish_y));
      this.context.stroke() ;
      //str = "#3QUAY(250M)";
      //this.drawRotateText(str, CZ(Q3_Start_x + 18), CZ(Q3_Start_y + 8), "m_fntQuay", "black", rad);
      this.context.closePath() ;
      
      this.context.beginPath() ;
      this.context.strokeStyle = "grey";
      this.context.lineWidth   = 0.5;
      
      for (i = Math.ceil(ex), j = 0; i >= 0 ; i -= 10 , j++){
      
        m_sx = this.Q3_Finish_x - Math.ceil(CalRotPosX(i, 0, rad) + 0.5);
        m_sy = this.Q3_Finish_y - Math.ceil(CalRotPosY(i, 0, rad) + 0.5);
        
        if ( (j % 5 == 0) && j != 0 && j < 26){
          m_ex = this.Q3_Finish_x - Math.ceil(CalRotPosX(i, 7, rad) + 0.5);
          m_ey = this.Q3_Finish_y - Math.ceil(CalRotPosY(i, 7, rad) + 0.5);

          str = String(j * 10);
          this.drawRotateText(str, CZ(m_ex - 6), CZ(m_sy - 5) , "m_fntQuayDesc", "blue", rad);
        }
        else {
          m_ex = this.Q3_Finish_x - Math.ceil(CalRotPosX(i, 4, rad) + 0.5);
          m_ey = this.Q3_Finish_y - Math.ceil(CalRotPosY(i, 4, rad) + 0.5);

        }
        if( j != 0 && j <= 25){
        
          this.context.moveTo(CZ(m_sx) + 2, CZ(m_sy));
          this.context.lineTo(CZ(m_ex) + 2, CZ(m_ey));
            
        }
      
      }
      this.context.stroke() ;
      this.context.closePath();
      
      //#3B QUAY DRAWING

      // Drawing 1/4 circle red color dùng hàm arc(x,y,r,start,stop)
      this.context.beginPath();
      this.context.fillStyle = "red";
      this.context.moveTo(this.Q3_Finish_x, this.Finish_Y );//this.Q3_Finish_y + 50 change by this.Q3_Finish_y
      this.context.arc(this.Q3_Finish_x, this.Finish_Y, 50, 1*Math.PI, 1.5*Math.PI); //this.Q3_Finish_y + 50 - 1 change by this.Q3_Finish_y
      this.context.fill();
      this.context.closePath();


      this.Q4_Start_x = this.Q3_Finish_x - 15;
      this.Q4_Start_y = this.Q3_Finish_y;
      this.Q4_Finish_x = this.Q4_Start_x - 300;
      this.Q4_Finish_y = this.Q3_Finish_y; 
      
      this.context.beginPath();
      this.context.strokeStyle = "black";
      this.context.lineWidth   = 1;
      this.context.moveTo(CZ(this.Q3_Finish_x), CZ(this.Q3_Finish_y));
      this.context.lineTo(CZ(this.Q3_Finish_x), CZ(this.Q3_Finish_y + 50));
      this.context.stroke() ;
      this.context.closePath();

      this.context.beginPath();	
      this.context.strokeStyle = "black";
      this.context.lineWidth  = 1 ;
      this.context.rect(CZ(this.Q2_Start_x - 300) + 1, this.Start_Y + 10 , 280, 70);//25
      //this.context.rect(CZ(Q2_Start_x - 300) + 1, 25 , 280, 20);
      this.context.stroke() ;
      this.context.closePath() ;
      
      //SEA TRIAL INFORMATION
      this.context.fillStyle = "#d4ecf8";
      this.context.fillRect(CZ(this.Q2_Start_x - 300) + 1, this.Start_Y + 10 , 280, 20);//25
      this.context.strokeStyle = "black";
      this.context.lineWidth = 1;
      this.context.font = "bold 11px Arial";
      this.context.fillStyle = "black";
      this.context.textAlign = "center";
      this.context.textBaseline = "middle";
      
      // Header
      this.context.strokeRect(CZ(this.Q2_Start_x - 300) + 1, this.Start_Y + 10 , 280, 20);//25
      this.drawText("SEA TRIAL INFORMATION", CZ(this.Q2_Start_x - 300) + 140, this.Start_Y + 10, "m_fntdft", "black", "1");//25
      
    },
    ShowHeaderInfo() { //get data from SQL
      // console.log("Showing header info...", this.selectedDate);
      let rect_left = this.Start_X ;
      let rect_top  = this.Start_Y - 20;
      let params = {strStartDate: this.selectedDate,      } 

      getSummaryStatus(params)
        .then(res => {  
            // console.log("Showing header info...", res.body);
          this.drawText(res.body, rect_left, rect_top, "m_fntQuay", "black", "0");  	
          this.context.restore();
        })
    },
    drawCurDockEvent() {//Dock Information
      // console.log("Drawing current dock event...");
      let Start_PosX, Start_PosY;
      let iWidth, iCellDockWidth, iCellBatchWidth, iCellWidth;
      let i, iCellHeight ;
      let rect_top, rect_left, str, strOld_dock;

      let params = {strStartDate: this.selectedDate,      } 
      this.context.save(); 

      getCurDockEvent(params)
          .then(res => {  
            // console.log("Drawing current dock event...", res.list); 
            if (res.list.length > 0){

              this.context.beginPath();
              this.context.strokeStyle = "black";
              this.context.lineWidth  = 1 ;
              this.context.fillStyle = "lightgray" ;
              
              Start_PosX = this.M2_Start_x + 25;
              Start_PosY = this.Start_Y + CZ(165);// + 200;
            
              iCellDockWidth	= 50;
              iCellBatchWidth	= 60;
              iCellWidth 		= 65;
              iWidth			= iCellWidth*10;
              iCellHeight		= 40;              

              this.context.fillStyle = "#d4ecf8";
              this.context.fillRect(Start_PosX, Start_PosY, iWidth, 60);//0,0
              
              this.context.strokeStyle = "black";
              this.context.lineWidth = 1;
              this.context.font = "normal 12px Arial";
              this.context.fillStyle = "black";
              //Add more
              this.context.textAlign = "center";
              this.context.textBaseline = "middle";
              
              // Header
              this.context.strokeRect(Start_PosX, Start_PosY, iWidth, 20);//0,0,width,30
              // this.context.fillText("DOCK INFORMATION", Start_PosX + iWidth / 2, Start_PosY + 10);
              this.drawText("DOCK INFORMATION", Start_PosX + iWidth / 2,  Start_PosY + 0, "m_fntweather", "black", "1"); 
              
              // Column headers with rowspan = 2
              const headers = [
                "Dock", "Ship No", "Ship Type", "Duration", "K/L", "F/T", "L/C"
              ];
              const widths = [65, 65, 65, 65, 65, 65, 65];
              let x = Start_PosX;
              let y = Start_PosY + 20;
              
              headers.forEach((header, index) => {
                this.context.strokeRect(x, y, widths[index], 40); // Rowspan effect
                // this.context.fillText(header, x + widths[index] / 2, y + 20);
                this.drawText(header, x + widths[index] / 2, y + 10, "m_fntweather", "black", "1"); 
                x += widths[index];
              });
              
              // Block Erection Status Header
              this.context.strokeRect(x, y, 195, 20);
              // this.context.fillText("Block Erection Status (EA)", x + 97.5, y + 10);
              this.drawText("Block Erection Status (EA)",  x + 97.5, y, "m_fntweather", "black", "1"); 
              
              // Sub-columns for Block Erection Status
              let subHeaders = ["Plan(a)", "Result(b)", "Rate(b/a)"];
              let subWidths = [65, 65, 65];
              y += 20;
              
              subHeaders.forEach((subHeader, index) => {
                this.context.strokeRect(x, y, subWidths[index], 20);
                // this.context.fillText(subHeader, x + subWidths[index] / 2, y + 10);
                this.drawText(subHeader,  x + subWidths[index] / 2, y, "m_fntweather", "black", "1"); 
                x += subWidths[index];
              });             
          
              iCellHeight = 20 ;
              Start_PosY = Start_PosY + 60; //60
              
              this.context.strokeStyle = "black";
							this.context.lineWidth  = 0.5 ;

              for(i=0 ; i < res.list.length ; i++) {
                
                let curDockEvent = {};
                      
                curDockEvent.kl 		     = res.list[i].kl;
                curDockEvent.lc 		     = res.list[i].lc;
                curDockEvent.loc 		     = res.list[i].loc;
                curDockEvent.dock 	     = res.list[i].dock;  
                curDockEvent.ftdte 	     = res.list[i].ftdte;
                curDockEvent.fttime      = res.list[i].fttime;
                curDockEvent.dur 		     = res.list[i].dur;
                curDockEvent.shipno      = res.list[i].shipno;
                curDockEvent.shiptype    = res.list[i].shiptype;
                curDockEvent.erectplan   = res.list[i].erectplan;
                curDockEvent.erectresult = res.list[i].erectresult;
                curDockEvent.resultper   = res.list[i].resultper;
                
                //DOCK
                rect_left = Start_PosX  + Math.ceil(iCellWidth/2);
                rect_top  = Start_PosY + i * iCellHeight;
                if (curDockEvent.dock != strOld_dock){
                  //DOCK
                  str = curDockEvent.dock ;
                  if(str === null) str = ""; 
                  this.drawText(str, rect_left , rect_top, "m_fntweather", "black", "1"); 
                  
                  if( i != 0){
										this.context.moveTo(Start_PosX, rect_top);
										this.context.lineTo(Start_PosX + iCellWidth, rect_top);
									} 
                }                              
                //SHIP NO
                str = curDockEvent.shipno;
                if(str === null) str = "";
                rect_left = Start_PosX + iCellWidth + Math.ceil(iCellWidth/2) ;
                rect_top  = Start_PosY + i * iCellHeight;
                this.drawText(str, rect_left , rect_top, "m_fntweather", "black", "1");
                //SHIP TYPE
                str = String(curDockEvent.shiptype) ; 
                if(str === null) str = "";
                rect_left = Start_PosX + iCellWidth*2 +  Math.ceil(iCellWidth/2);
                rect_top  = Start_PosY + i * iCellHeight;
                this.drawText(str, rect_left , rect_top, "m_fntweather", "black", "1");                
                //DURATION
                str = String(curDockEvent.dur) ; 
                if(str === null) str = "";
                rect_left = Start_PosX + iCellWidth*3 +  Math.ceil(iCellWidth/2);
                rect_top  = Start_PosY + i * iCellHeight;
                this.drawText(str, rect_left , rect_top, "m_fntweather", "black", "1");                
                //K/L
                str = curDockEvent.kl; 
                if(str === null) str = "";
                rect_left = Start_PosX + iCellWidth*4 + Math.ceil(iCellWidth/2);
                rect_top  = Start_PosY + i * iCellHeight;
                this.drawText(str, rect_left , rect_top, "m_fntweather", "black", "1");
                //FT DATE
                str = curDockEvent.ftdte;
                if(str === null) str = "";
                rect_left = Start_PosX + iCellWidth*5 + Math.ceil(iCellWidth/2);
                rect_top  = Start_PosY + i * iCellHeight;
                this.drawText(str, rect_left , rect_top, "m_fntweather", "black", "1");
                //L/C
                str = curDockEvent.lc;
                if(str === null) str = "";
                rect_left = Start_PosX + iCellWidth*6 + Math.ceil(iCellWidth/2);
                rect_top  = Start_PosY + i * iCellHeight;
                this.drawText(str, rect_left , rect_top, "m_fntweather", "black", "1");
                //ERECT_PLAN
                str = curDockEvent.erectplan;
                if(str === null) str = "";
                rect_left = Start_PosX + iCellWidth*7 + Math.ceil(iCellWidth/2);
                rect_top  = Start_PosY + i * iCellHeight;
                this.drawText(str, rect_left , rect_top, "m_fntweather", "black", "1");
                //ERECT_RESULT
                str = curDockEvent.erectresult;
                if(str === null) str = "";
                rect_left = Start_PosX + iCellWidth*8 + Math.ceil(iCellWidth/2);
                rect_top  = Start_PosY + i * iCellHeight;
                this.drawText(str, rect_left , rect_top, "m_fntweather", "black", "1");
                //RESULT_PER
                str = curDockEvent.resultper;
                if(str === null) str = "";
                rect_left = Start_PosX + iCellWidth*9 + Math.ceil(iCellWidth/2);
                rect_top  = Start_PosY + i * iCellHeight;
                this.drawText(str, rect_left , rect_top, "m_fntweather", "black", "1"); 

                //Vertical Line
                this.context.moveTo(Start_PosX + iCellWidth*0, Start_PosY + i*iCellHeight); //Start Dock
                this.context.lineTo(Start_PosX + iCellWidth*0, Start_PosY + (i +1 )*iCellHeight);
                
                this.context.moveTo(Start_PosX + iCellWidth*1, Start_PosY + i*iCellHeight); //Dock
                this.context.lineTo(Start_PosX + iCellWidth*1, Start_PosY + (i +1 )*iCellHeight);
            
                this.context.moveTo(Start_PosX + iCellWidth*2, Start_PosY + i*iCellHeight); //Ship No
                this.context.lineTo(Start_PosX + iCellWidth*2, Start_PosY + (i + 1)*iCellHeight);
            
                this.context.moveTo(Start_PosX + iCellWidth*3, Start_PosY + i*iCellHeight); //Ship Type
                this.context.lineTo(Start_PosX + iCellWidth*3, Start_PosY + (i + 1)*iCellHeight);
            
                this.context.moveTo(Start_PosX + iCellWidth*4, Start_PosY + i*iCellHeight); //Duration
                this.context.lineTo(Start_PosX + iCellWidth*4, Start_PosY + (i + 1)*iCellHeight);
            
                this.context.moveTo(Start_PosX + iCellWidth*5, Start_PosY + i*iCellHeight); //K/L
                this.context.lineTo(Start_PosX + iCellWidth*5, Start_PosY + (i + 1)*iCellHeight);
            
                this.context.moveTo(Start_PosX + iCellWidth*6, Start_PosY + i*iCellHeight); //F/T
                this.context.lineTo(Start_PosX + iCellWidth*6, Start_PosY + (i + 1)*iCellHeight);
          
                this.context.moveTo(Start_PosX + iCellWidth*7, Start_PosY + i * iCellHeight); //L/C
                this.context.lineTo(Start_PosX + iCellWidth*7, Start_PosY + (i + 1) * iCellHeight);

                this.context.moveTo(Start_PosX + iCellWidth*8, Start_PosY + i * iCellHeight); //PLAN
                this.context.lineTo(Start_PosX + iCellWidth*8, Start_PosY + (i + 1) * iCellHeight);

                this.context.moveTo(Start_PosX + iCellWidth*9, Start_PosY + i * iCellHeight); //RESULT
                this.context.lineTo(Start_PosX + iCellWidth*9, Start_PosY + (i + 1) * iCellHeight);

                this.context.moveTo(Start_PosX + iCellWidth*10, Start_PosY + i * iCellHeight); //RATE
                this.context.lineTo(Start_PosX + iCellWidth*10, Start_PosY + (i + 1) * iCellHeight);
                
                this.context.moveTo(Start_PosX + iCellWidth, Start_PosY + (i + 1) * iCellHeight); //Each row bottom line
                this.context.lineTo(Start_PosX + iWidth, Start_PosY + (i + 1) * iCellHeight);

                strOld_dock = curDockEvent.dock ;
                //this.context.stroke();
                
              } //end for loop;
            
              this.context.moveTo(Start_PosX , Start_PosY  + iCellHeight * i); //Left line
              this.context.lineTo(Start_PosX + iCellWidth, Start_PosY + i * iCellHeight);
              
              this.context.stroke();
              this.context.closePath();
            }// end if                      
          })      	
          this.context.restore();	
    },
    drawBlkStock() {//Block Stock Status
      // console.log("Drawing block stock...");
      let Start_PosX, Start_PosY;
      let i, iCellWidth, iCellHeight ;
      let rect_top, rect_left, str ;
          
      let params = {strStartDate: this.selectedDate,      } 
        
      this.context.save();
        
      getBlkStock(params)
          .then(res => {  
            // console.log("Drawing block stock...", res.list); 
            if (res.list.length > 0){

              this.context.beginPath();	
              this.context.strokeStyle = "black";
              this.context.lineWidth  = 1 ;
              this.context.fillStyle = "#d4ecf8" ;
              //Old position
              // Start_PosX = this.D2_Start_x + 365 ;
              // Start_PosY = 260;
              
              //New Moving from Dock 2 to Material information
              Start_PosX = this.M1_Start_x + 15;
              Start_PosY = this.Start_Y + CZ(10);//CZ(25);
              
              iCellWidth  = 55;//72
              iCellHeight = 40;
              
              this.context.rect(Start_PosX, Start_PosY, iCellWidth * 3 , iCellHeight);
              this.context.fill();
              
              this.context.moveTo(Start_PosX		   , Start_PosY);
              this.context.lineTo(Start_PosX + iCellWidth * 3, Start_PosY); 
            
              this.context.moveTo(Start_PosX		   , Start_PosY + 20);
              this.context.lineTo(Start_PosX + iCellWidth * 3, Start_PosY + 20); 
            
              this.context.moveTo(Start_PosX, Start_PosY);
              this.context.lineTo(Start_PosX, Start_PosY + 40);
              
              this.context.moveTo(Start_PosX + iCellWidth * 3, Start_PosY); 
              this.context.lineTo(Start_PosX + iCellWidth * 3, Start_PosY + 20);
              
              str = "Block Stock Status";
              rect_left = Start_PosX  + Math.ceil(iCellWidth * 3/2);
              rect_top  = Start_PosY ; 
              this.drawText(str.toUpperCase(), rect_left, rect_top + 1, "m_fntweather", "black", "1"); 
            
              this.context.moveTo(Start_PosX, Start_PosY + 20); 
              this.context.lineTo(Start_PosX + iCellWidth * 3, Start_PosY + 20);
              
              str = "Total";
              rect_left = Start_PosX  + Math.ceil(iCellWidth/2);
              rect_top  = Start_PosY + 20 ; 
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
              
              this.context.moveTo(Start_PosX + iCellWidth, Start_PosY + 20); //Total
              this.context.lineTo(Start_PosX + iCellWidth, Start_PosY + 40);
            
              str = "Used";
              rect_left = Start_PosX  + iCellWidth + Math.ceil(iCellWidth/2);
              rect_top  = Start_PosY + 20 ; 
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
        
            
              this.context.moveTo(Start_PosX + iCellWidth * 2, Start_PosY + 20); //Used
              this.context.lineTo(Start_PosX + iCellWidth * 2, Start_PosY + 40);
            
              str = "Remain";
              rect_left = Start_PosX  + iCellWidth * 2 + Math.ceil(iCellWidth/2);
              rect_top  = Start_PosY + 20 ; 
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
            
              this.context.moveTo(Start_PosX + iCellWidth * 3 , Start_PosY + 20); //Remain
              this.context.lineTo(Start_PosX + iCellWidth * 3 , Start_PosY + 40);                         
              this.context.stroke();
            
              iCellHeight = 20 ;
              Start_PosY = Start_PosY + 40; 
            
              for(i= 0; i < res.list.length ; i++) {
                
                  let BlkStockCnt = {};
                  
                  //	WK_DATE, TOT_CNT, USED_CNT, RM_CNT			
                // BlkStockCnt.wkdate 	= res.list[i].wkdate;
                BlkStockCnt.totcnt 	= res.list[i].totcnt;
                BlkStockCnt.usedcnt = res.list[i].usedcnt;
                BlkStockCnt.rmcnt	 	= res.list[i].rmcnt;  

                str = BlkStockCnt.totcnt;	
                rect_left = Start_PosX  + Math.ceil(iCellWidth/2);
                rect_top  = Start_PosY + i * iCellHeight;
                this.drawText(str, rect_left , rect_top, "m_fntweather", "black", "1");
                
                str = BlkStockCnt.usedcnt;	
                rect_left = Start_PosX  + iCellWidth +  Math.ceil(iCellWidth/2);
                rect_top  = Start_PosY + i * iCellHeight;
                this.drawText(str, rect_left , rect_top, "m_fntweather", "black", "1");
                
                str = BlkStockCnt.rmcnt;	
                rect_left = Start_PosX  + iCellWidth * 2 +  Math.ceil(iCellWidth/2);
                rect_top  = Start_PosY + i * iCellHeight;
                this.drawText(str, rect_left , rect_top, "m_fntweather", "black", "1");
                
                //Vertical Line
                this.context.moveTo(Start_PosX + iCellWidth, Start_PosY + i * iCellHeight); //Dock
                this.context.lineTo(Start_PosX + iCellWidth, Start_PosY + (i + 1) * iCellHeight);
            
                this.context.moveTo(Start_PosX + iCellWidth * 2, Start_PosY + i * iCellHeight); //Batch
                this.context.lineTo(Start_PosX + iCellWidth * 2, Start_PosY + (i + 1) * iCellHeight);
            
                this.context.moveTo(Start_PosX + iCellWidth * 3, Start_PosY + i * iCellHeight); //dur
                this.context.lineTo(Start_PosX + iCellWidth * 3, Start_PosY + (i + 1) * iCellHeight);
              
              }
            
              this.context.moveTo(Start_PosX , Start_PosY + i * iCellHeight); //Buttom line
              this.context.lineTo(Start_PosX + iCellWidth * 3, Start_PosY + i * iCellHeight);
            
              this.context.moveTo(Start_PosX , Start_PosY ); //Left line
              this.context.lineTo(Start_PosX , Start_PosY + i * iCellHeight);
                
              this.context.stroke();
              this.context.closePath();
              
            } // end if  
        
        }); //request done ending 
      
      this.context.restore();	
    },
    drawShipEvent() {//Main Event of Ship Plan/actual
      // console.log("Drawing ship event...");
      let Start_PosX, Start_PosY;
      let iCellWidth, iCellHeight, iCellTitleWidth, iCellTitleSub1Width, iCellTitleSub2Width, iCellPMWidth, iCellTitleHeight;
      let iCellDivWidth, iCellOwnerWidth, iCellDutyWidth;
      let rect_top, rect_left ;
      let j = 0, k = 0 , i = 0 ;
      let rad, str, strOld_dock ;
      //var strLDock, strCDock, strSHIP_OWN, strFirstRow;
      let params = {strStartDate: this.selectedDate,      } 
        
      getShipEvent(params)
        .then(res => {  
          // console.log("Drawing ship event...", res.list); 
          if (res.list.length > 0){	
            this.context.strokeStyle = "black";
            this.context.lineWidth  = 0.5 ;
            this.context.fillStyle = "lightgray" ;
          
            Start_PosY = 660;
            Start_PosX = this.M1_Start_x + 30;

            iCellWidth = 40;
            iCellHeight= 20;
            
            iCellDivWidth = 60;
            iCellOwnerWidth = 75;
            iCellDutyWidth = 70;
            
            //Vẽ Header
            this.context.fillStyle = "#d4ecf8";
            this.context.fillRect(Start_PosX, Start_PosY, 645, 40);
            
            this.context.strokeStyle = "black";
            this.context.lineWidth = 1;
            this.context.font = "normal 11px Arial";
            this.context.fillStyle = "black";
            this.context.textAlign = "center";
            this.context.textBaseline = "middle";
            
            // Header
            rect_left = Start_PosX + 10 ;
            rect_top  = Start_PosY - 25;
            this.drawText("Main Events of Ship Plan/Actual", rect_left, rect_top, "m_fntmainevent", "black", "0"); 
            
            // Column headers with rowspan = 2
            const headers = [
              "Location", "Ship", "Owner Serial", "L/C", "S/P", "D/G Start", "M/E Start", "DWT"
            ];
            const widths = [60, 40, 75, 40, 40, 40, 40, 40];
            let x = Start_PosX;
            let y = Start_PosY;
            
            headers.forEach((header, index) => {
              this.context.strokeRect(x, y, widths[index], 40); // Rowspan effect
              // this.context.fillText(header, x + widths[index] / 2, y + 20);
              if (header === "D/G Start") {
                  this.context.fillText("D/G", x + widths[index] / 2, y + 14);
                  this.context.fillText("Start", x + widths[index] / 2, y + 26);
              }else if (header === "M/E Start") {
                  this.context.fillText("M/E", x + widths[index] / 2, y + 14);
                  this.context.fillText("Start", x + widths[index] / 2, y + 26);
              }  
              else {
                  this.context.fillText(header, x + widths[index] / 2, y + 20);
              }
              x += widths[index];
            });
            
            // S/T Header
            this.context.strokeRect(x, y, 80, 20);
            this.context.fillText("S/T", x + 40, y + 10);
            
            // Sub-columns for Block Erection Status
            let subHeaders = ["Sail", "Enter"];
            let subWidths = [40, 40];
            y += 20;
            
            subHeaders.forEach((subHeader, index) => {
              this.context.strokeRect(x, y, subWidths[index], 20);
              this.context.fillText(subHeader, x + subWidths[index] / 2, y + 10);
              x += subWidths[index];
            });

            // Column headers with rowspan = 2
            const headers1 = [
              "N/C", "D/L", "Sail Out", "Duty C/M"
            ];
            const widths1 = [40, 40, 40, 70];
            let x1 = Start_PosX + 455;
            let y1 = Start_PosY;
            
            headers1.forEach((header, index) => {
              this.context.strokeRect(x1, y1, widths1[index], 40); // Rowspan effect
              // this.context.fillText(header, x1 + widths1[index] / 2, y1 + 20);
              if (header === "Sail Out") {
                  this.context.fillText("Sail", x1 + widths1[index] / 2, y1 + 14);
                  this.context.fillText("Out", x1 + widths1[index] / 2, y1 + 26);
              } else {
                  this.context.fillText(header, x1 + widths1[index] / 2, y1 + 20);
              }
              x1 += widths1[index];
            });
                        
            Start_PosY = Start_PosY + 40 ;
            this.context.fillStyle = "LightCyan" ;
            
            for(i= 0; i < res.list.length ; i++) {
              
              let shipEventList = {};
              shipEventList.shipno 	  = res.list[i].shipno;
              shipEventList.shipown 	= res.list[i].shipown;
              shipEventList.dock 		  = res.list[i].dock;
              shipEventList.lc 		    = res.list[i].lc;
              shipEventList.plc 		  = res.list[i].plc;
              shipEventList.sp		    = res.list[i].sp;
              shipEventList.psp 		  = res.list[i].psp;
              shipEventList.dg 		    = res.list[i].dg;
              shipEventList.pdg 		  = res.list[i].pdg;
              shipEventList.me		    = res.list[i].me;
              shipEventList.pme 		  = res.list[i].pme;
              shipEventList.dwt 		  = res.list[i].dwt;
              shipEventList.pdwt 	    = res.list[i].pdwt;
              shipEventList.sst		    = res.list[i].sst;	
              shipEventList.psst 	    = res.list[i].p_sst;
              shipEventList.fst 		  = res.list[i].fst;
              shipEventList.pfst 	    = res.list[i].pfst;
              shipEventList.nc		    = res.list[i].ncdt;
              shipEventList.pnc 		  = res.list[i].pnc;
              shipEventList.dl 		    = res.list[i].dl;
              shipEventList.pdl 		  = res.list[i].pdl;
              shipEventList.so 		    = res.list[i].so;
              shipEventList.pso		    = res.list[i].pso;
              shipEventList.pm 		    = res.list[i].pm;
              shipEventList.ncdt 	    = res.list[i].ncdt;
              shipEventList.cmpic 	  = res.list[i].cmpic;              
              
              rect_left = Start_PosX  + Math.ceil(iCellDivWidth/2);
              rect_top  = Start_PosY +  i*iCellHeight;
              if(shipEventList.dock != strOld_dock){
                str = (shipEventList.dock ==='D'? 'Dock':'Quay') ; //Divison
                if(str === null) str = "";                
                this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
                this.context.beginPath();
                if( i != 0)
                {
                  this.context.moveTo(Start_PosX, rect_top);
                  this.context.lineTo(Start_PosX + iCellDivWidth, rect_top);
                }
                
              } 
              this.context.moveTo(Start_PosX, rect_top); //Dock
							this.context.lineTo(Start_PosX, rect_top + iCellHeight);
              
              //Dock Hor end line
              this.context.moveTo(Start_PosX + iCellDivWidth, rect_top);
              this.context.lineTo(Start_PosX + iCellDivWidth, rect_top + iCellHeight) ;
              this.context.stroke();
              this.context.closePath();

              //Ship No
              str = shipEventList.shipno ; //Ship No
              if(str === null) str = "";//shipEventList.shipno ?? ""
              rect_left = Start_PosX  + iCellDivWidth + Math.ceil(iCellWidth/2);
              rect_top  = Start_PosY +  i*iCellHeight;
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
              this.context.beginPath();
              this.context.moveTo(Start_PosX + iCellDivWidth + iCellWidth, rect_top);
              this.context.lineTo(Start_PosX + iCellDivWidth + iCellWidth, rect_top + iCellHeight) ;
              this.context.stroke();
              this.context.closePath();
              //Ship Owner
              str = shipEventList.shipown ;//+ " #" + shipEventList.seriesno ;  //Ship ower + serial
              if(str === null) str = "";
              rect_left = Start_PosX + iCellDivWidth + iCellWidth;
              rect_top  = Start_PosY +  i*iCellHeight;
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "0"); 
              this.context.beginPath();
              this.context.moveTo(Start_PosX + iCellDivWidth + iCellWidth + iCellOwnerWidth, rect_top);
              this.context.lineTo(Start_PosX + iCellDivWidth + iCellWidth + iCellOwnerWidth, rect_top + iCellHeight) ;			
              this.context.stroke();
              this.context.closePath();
              //L/C  
              str = shipEventList.lc ;	
              if(str === null) str = "";
              rect_left = Start_PosX  + iCellDivWidth + iCellWidth + iCellOwnerWidth + Math.ceil(iCellWidth/2);
              rect_top  = Start_PosY +  i*iCellHeight;
              if(shipEventList.plc == "1") {
                this.context.beginPath();
                this.context.rect(Start_PosX + iCellDivWidth + iCellWidth + iCellOwnerWidth + 1, rect_top + 1, iCellWidth, iCellHeight -1 );
                this.context.fill();
                this.context.closePath();
              }
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
              this.context.beginPath();
              this.context.moveTo(Start_PosX + iCellDivWidth + iCellWidth*2 + iCellOwnerWidth, rect_top );
              this.context.lineTo(Start_PosX + iCellDivWidth + iCellWidth*2 + iCellOwnerWidth, rect_top + iCellHeight) ;
              this.context.stroke();
              this.context.closePath();
              //S/P
              str = shipEventList.sp ;	
              if(str === null) str = "";
              rect_left = Start_PosX  + iCellDivWidth + iCellWidth*2 + iCellOwnerWidth + Math.ceil(iCellWidth/2);
              rect_top  = Start_PosY +  i*iCellHeight;	
              if(shipEventList.psp == "1") {
                this.context.beginPath();
                this.context.rect(Start_PosX  + iCellDivWidth + iCellWidth*2 + iCellOwnerWidth + 1, rect_top + 1, iCellWidth, iCellHeight - 1);
                this.context.fill();
                this.context.closePath();
              }
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
              this.context.beginPath();
              this.context.moveTo(Start_PosX + iCellDivWidth + iCellWidth*3 + iCellOwnerWidth, rect_top );
              this.context.lineTo(Start_PosX + iCellDivWidth + iCellWidth*3 + iCellOwnerWidth, rect_top + iCellHeight) ;
              this.context.stroke();
              this.context.closePath();
              //D/G Start
              str = shipEventList.dg ;	
              if(str === null) str = "";
              rect_left = Start_PosX  + iCellDivWidth + iCellWidth*3 + iCellOwnerWidth + Math.ceil(iCellWidth/2);
              rect_top  = Start_PosY +  i*iCellHeight;	
              if(shipEventList.pdg == "1") {
                this.context.beginPath();
                this.context.rect(Start_PosX  + iCellDivWidth + iCellWidth*3 + iCellOwnerWidth + 1, rect_top + 1, iCellWidth, iCellHeight - 1);
                this.context.fill();
                this.context.closePath();
              }
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
              this.context.beginPath();
              this.context.moveTo(Start_PosX + iCellDivWidth + iCellWidth*4 + iCellOwnerWidth, rect_top );
              this.context.lineTo(Start_PosX + iCellDivWidth + iCellWidth*4 + iCellOwnerWidth, rect_top + iCellHeight) ;
              this.context.stroke();
              this.context.closePath();
              
              //M/E Start
              str = shipEventList.me ;	
              if(str === null) str = "";
              rect_left = Start_PosX  + iCellDivWidth + iCellWidth*4 + iCellOwnerWidth + Math.ceil(iCellWidth/2);
              rect_top  = Start_PosY +  i*iCellHeight;	
              if(shipEventList.pme == "1") {
                this.context.beginPath();
                this.context.rect(Start_PosX  + iCellDivWidth + iCellWidth*4 + iCellOwnerWidth + 1, rect_top + 1, iCellWidth, iCellHeight - 1);
                this.context.fill();
                this.context.closePath();
              }
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
              this.context.beginPath();
              this.context.moveTo(Start_PosX + iCellDivWidth + iCellWidth*5 + iCellOwnerWidth, rect_top );
              this.context.lineTo(Start_PosX + iCellDivWidth + iCellWidth*5 + iCellOwnerWidth, rect_top + iCellHeight) ;
              this.context.stroke();
              this.context.closePath();
              //DWT
              str = shipEventList.dwt ;	
              if(str === null) str = "";
              rect_left = Start_PosX  + iCellDivWidth + iCellWidth*5 + iCellOwnerWidth + Math.ceil(iCellWidth/2);
              rect_top  = Start_PosY +  i*iCellHeight;	
              if(shipEventList.pdwt == "1") {
                this.context.beginPath();
                this.context.rect(Start_PosX  + iCellDivWidth + iCellWidth*5 + iCellOwnerWidth + 1, rect_top + 1, iCellWidth, iCellHeight - 1);
                this.context.fill();
                this.context.closePath();
              }
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
              this.context.beginPath();
              this.context.moveTo(Start_PosX + iCellDivWidth + iCellWidth*6 + iCellOwnerWidth, rect_top );
              this.context.lineTo(Start_PosX + iCellDivWidth + iCellWidth*6 + iCellOwnerWidth, rect_top + iCellHeight) ;
              this.context.stroke();
              this.context.closePath();
              //Seatrail start
              str = shipEventList.sst ;	
              if(str === null) str = "";
              rect_left = Start_PosX  + iCellDivWidth + iCellWidth*6 + iCellOwnerWidth + Math.ceil(iCellWidth/2);
              rect_top  = Start_PosY +  i*iCellHeight;	
              if(shipEventList.psst == "1") {
                this.context.beginPath();
                this.context.rect(Start_PosX  + iCellDivWidth + iCellWidth*6 + iCellOwnerWidth + 1, rect_top + 1, iCellWidth, iCellHeight - 1);
                this.context.fill();
                this.context.closePath();
              }
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
              this.context.beginPath();
              this.context.moveTo(Start_PosX + iCellDivWidth + iCellWidth*7 + iCellOwnerWidth, rect_top );
              this.context.lineTo(Start_PosX + iCellDivWidth + iCellWidth*7 + iCellOwnerWidth, rect_top + iCellHeight) ;
              this.context.stroke();
              this.context.closePath();              
              //Seatrail end
              str = shipEventList.fst ;	
              if(str === null) str = "";
              rect_left = Start_PosX  + iCellDivWidth + iCellWidth*7 + iCellOwnerWidth + Math.ceil(iCellWidth/2);
              rect_top  = Start_PosY +  i*iCellHeight;	
              if(shipEventList.pfst == "1") {
                this.context.beginPath();
                this.context.rect(Start_PosX  + iCellDivWidth + iCellWidth*7 + iCellOwnerWidth + 1, rect_top + 1, iCellWidth, iCellHeight - 1);
                this.context.fill();
                this.context.closePath();
              }
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
              this.context.beginPath();
              this.context.moveTo(Start_PosX + iCellDivWidth + iCellWidth*8 + iCellOwnerWidth, rect_top );
              this.context.lineTo(Start_PosX + iCellDivWidth + iCellWidth*8 + iCellOwnerWidth, rect_top + iCellHeight) ;
              this.context.stroke();
              this.context.closePath();                
              //NC
              str = shipEventList.nc ;	
              if(str === null) str = "";
              rect_left = Start_PosX  + iCellDivWidth + iCellWidth*8 + iCellOwnerWidth + Math.ceil(iCellWidth/2);
              rect_top  = Start_PosY +  i*iCellHeight;	
              if(shipEventList.pnc == "1") {
                this.context.beginPath();
                this.context.rect(Start_PosX  + iCellDivWidth + iCellWidth*8 + iCellOwnerWidth + 1, rect_top + 1, iCellWidth, iCellHeight - 1);
                this.context.fill();
                this.context.closePath();
              }
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
              this.context.beginPath();
              this.context.moveTo(Start_PosX + iCellDivWidth + iCellWidth*9 + iCellOwnerWidth, rect_top );
              this.context.lineTo(Start_PosX + iCellDivWidth + iCellWidth*9 + iCellOwnerWidth, rect_top + iCellHeight) ;
              this.context.stroke();
              this.context.closePath();                
              //DL
              str = shipEventList.dl ;	
              if(str === null) str = "";
              rect_left = Start_PosX  + iCellDivWidth + iCellWidth*9 + iCellOwnerWidth + Math.ceil(iCellWidth/2);
              rect_top  = Start_PosY +  i*iCellHeight;	
              if(shipEventList.pdl == "1") {
                this.context.beginPath();
                this.context.rect(Start_PosX  + iCellDivWidth + iCellWidth*9 + iCellOwnerWidth + 1, rect_top + 1, iCellWidth, iCellHeight - 1);
                this.context.fill();
                this.context.closePath();
              }
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
              this.context.beginPath();
              this.context.moveTo(Start_PosX + iCellDivWidth + iCellWidth*10 + iCellOwnerWidth, rect_top );
              this.context.lineTo(Start_PosX + iCellDivWidth + iCellWidth*10 + iCellOwnerWidth, rect_top + iCellHeight) ;
              this.context.stroke();
              this.context.closePath();
              //SO
              str = shipEventList.so ;	
              if(str === null) str = "";
              rect_left = Start_PosX  + iCellDivWidth + iCellWidth*10 + iCellOwnerWidth + Math.ceil(iCellWidth/2);
              rect_top  = Start_PosY +  i*iCellHeight;	
              if(shipEventList.pso == "1") {
                this.context.beginPath();
                this.context.rect(Start_PosX  + iCellDivWidth + iCellWidth*10 + iCellOwnerWidth + 1, rect_top + 1, iCellWidth, iCellHeight - 1);
                this.context.fill();
                this.context.closePath();
              }
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
              this.context.beginPath();
              this.context.moveTo(Start_PosX + iCellDivWidth + iCellWidth*11 + iCellOwnerWidth, rect_top );
              this.context.lineTo(Start_PosX + iCellDivWidth + iCellWidth*11 + iCellOwnerWidth, rect_top + iCellHeight) ;
              this.context.stroke();
              this.context.closePath();
              //CM_PIC
              str = shipEventList.cmpic ;	//CM_PIC
              if(str === null) str = "";
              rect_left = Start_PosX  + iCellDivWidth + iCellWidth*11 + iCellOwnerWidth + Math.ceil(iCellDutyWidth/2);
              rect_top  = Start_PosY +  i*iCellHeight;	
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
              this.context.beginPath();
              this.context.moveTo(Start_PosX + iCellDivWidth + iCellWidth*11 + iCellOwnerWidth + iCellDutyWidth, rect_top );
              this.context.lineTo(Start_PosX + iCellDivWidth + iCellWidth*11 + iCellOwnerWidth + iCellDutyWidth, rect_top + iCellHeight) ;
              this.context.stroke();
              this.context.closePath();

              //Each row bottom line
              this.context.beginPath();
              this.context.moveTo(Start_PosX + iCellDivWidth, rect_top + iCellHeight);
              this.context.lineTo(Start_PosX + iCellDivWidth + iCellOwnerWidth + iCellWidth*11 + iCellDutyWidth, rect_top + iCellHeight) ;
              this.context.stroke();
              this.context.closePath();

              // this.context.moveTo(Start_PosX , Start_PosY + i* iCellHeight); //Row left line
              // this.context.lineTo(Start_PosX , Start_PosY + i* iCellHeight + iCellHeight) ;
              
              strOld_dock = shipEventList.dock ;

              
                
            } //end for loop ;
            this.context.beginPath();
            this.context.moveTo(Start_PosX, Start_PosY  + iCellHeight * i);
            this.context.lineTo(Start_PosX + iCellDivWidth, Start_PosY  + iCellHeight * i);
            this.context.stroke() ;
            this.context.closePath();
            
          } // End if rtn chk
        }) ;  // End request function        
        this.context.restore();
    },
    ShowShip() {
      // console.log("Showing ship...");
      this.iOP_Cnt = 0;
      				
      let params = {strStartDate: this.selectedDate,      } 
        
      getShipList(params)
        .then(res => {  
          // console.log("Showing ship...", res.list); 
          if (res.list.length > 0){	
          
            //WK_DATE,SHIP_NO,OWNER,SERIES_NO,SHIP_NM,SKIND,LOA,BREADTH,
            //TEL,ETA,CONFIRM,LOC,TEMP_LOC,POS_X,POS_Y, CONT,ALONG,FUTURE,
            //F1,F2,F3,F4,FC,AC,A4,A3,A2,A1,B1
            
            for(let i = 0 ; i < res.list.length; i++){ 

              let shipList = {};
              shipList.cont 		= res.list[i].cont;
              shipList.loc 		  = res.list[i].loc;
              
              if (shipList.loc === "SS") this.iOP_Cnt++;//OP = SS
              // console.log("iOP_Cnt...", this.iOP_Cnt); 
              
            }
              
            for(let irow = 0 ; irow < res.list.length ; irow++){
              
              let shipObj = {};
              
              shipObj.wkdate 	= res.list[irow].wkdate;
              shipObj.shipno 	= res.list[irow].shipno; 
              shipObj.owner 		= res.list[irow].owner;
              shipObj.seriesno 	= res.list[irow].seriesno;
              shipObj.shipnm     = res.list[irow].shipnm;
              shipObj.skind 		= res.list[irow].skind;
              shipObj.loa 		= res.list[irow].loa;
              shipObj.breadth 	= res.list[irow].breadth;
              
              shipObj.tel 		= res.list[irow].tel;
              shipObj.eta 		= res.list[irow].eta;
              shipObj.confirm 	= res.list[irow].confirm;
              shipObj.loc 		= res.list[irow].loc;
              // shipObj.temploc 	= res.list[irow].temploc;
              shipObj.posx 		= res.list[irow].posx;
              shipObj.posy 		= res.list[irow].posy;
              shipObj.cont 		= res.list[irow].cont;
              shipObj.along 		= res.list[irow].along;
              shipObj.future 		= res.list[irow].future;
              
              shipObj.f1 			= res.list[irow].f1;
              shipObj.f2 			= res.list[irow].f2;
              shipObj.f3		 	= res.list[irow].f3;
              shipObj.f4 			= res.list[irow].f4;
              shipObj.fc 			= res.list[irow].fc;
              shipObj.ac 			= res.list[irow].ac;
              shipObj.a1 			= res.list[irow].a1;
              shipObj.a2 			= res.list[irow].a2;
              shipObj.a3 			= res.list[irow].a3;
              shipObj.a4 			= res.list[irow].a4;
              shipObj.b1 			= res.list[irow].b1;
              
              this.drawShip(shipObj);
              this.ShowShipDesc(shipObj) ;		
                  
            }
          }
        });	
    },
    drawMovingSCH() { //Ship's Moving Information
      // console.log("Drawing moving schedule...");
      let Start_PosX, Start_PosY;
      let iWidth, iCellDateWidth, iCellShipWidth, iCellTimeWidth, iCellContentWidth;
      let iCellHeight;						
      let i, str ;
      let rect_left, rect_top ;
      let strOld_date ;
      let ifromWidth = 0;

      let params = {strStartDate: this.selectedDate,      } 
      
      this.context.save();
        
      getMoveSch(params)
          .then(res => {  
          // console.log("Drawing moving schedule...", res.list); 
            if (res.list.length > 0){

              this.context.beginPath();	
              this.context.strokeStyle = "black";
              this.context.lineWidth  = 1 ;
              this.context.fillStyle = "#d4ecf8" ;
          
              Start_PosX = 10;
              Start_PosY = this.D1_Start_y + 58;
            
              iCellDateWidth		= 50;
              iCellShipWidth		= 70;
              iCellTimeWidth		= 100;
              iCellContentWidth	= 320;
              iWidth				= iCellDateWidth + iCellShipWidth + iCellTimeWidth + iCellContentWidth;
              iCellHeight			= 20;
              ifromWidth 			= Math.ceil(iCellTimeWidth/2)
            
              //pDC->SelectObject(&pDoc->m_Pen2);
              //pDC->SelectObject(&pDoc->m_fntSCH);
              
              this.context.rect(Start_PosX + 1, Start_PosY + 1, iWidth - 1 , iCellHeight * 2);
              this.context.fill();
              
              this.context.moveTo(Start_PosX		  , Start_PosY);
              this.context.lineTo(Start_PosX + iWidth, Start_PosY); 
            
              this.context.moveTo(Start_PosX		  , Start_PosY + iCellHeight * 2 );
              this.context.lineTo(Start_PosX + iWidth, Start_PosY + iCellHeight * 2 ); 
            
              this.context.moveTo(Start_PosX, Start_PosY);
              this.context.lineTo(Start_PosX, Start_PosY + iCellHeight * 2);
            
              this.context.moveTo(Start_PosX + iWidth, Start_PosY); 
              this.context.lineTo(Start_PosX + iWidth, Start_PosY + iCellHeight * 2);
              //this.context.stroke() ;
              
              str = "Ship's Moving Information";
              rect_left = Start_PosX + 10;
              rect_top  = Start_PosY - 25; 
              this.drawText(str, rect_left, rect_top, "m_fntMoving", "black", "0"); 
            
              str = "Date";
              rect_left = Start_PosX + Math.ceil(iCellDateWidth/2);
              rect_top  = Start_PosY + Math.ceil(iCellHeight/2) ; 
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
              
              this.context.moveTo(Start_PosX + iCellDateWidth, Start_PosY); //Date
              this.context.lineTo(Start_PosX + iCellDateWidth, Start_PosY + iCellHeight * 2);
            
              str = "Ship Name";
              rect_left = Start_PosX + iCellDateWidth + Math.ceil(iCellShipWidth/2) ;
              rect_top  = Start_PosY + Math.ceil(iCellHeight/2) ; 
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
            
              this.context.moveTo(Start_PosX + iCellDateWidth + iCellShipWidth, Start_PosY); //Ship
              this.context.lineTo(Start_PosX + iCellDateWidth + iCellShipWidth, Start_PosY + iCellHeight * 2);
            
              str = "Time Schedule";
              rect_left = Start_PosX + iCellDateWidth + iCellShipWidth + ifromWidth ;
              rect_top  = Start_PosY ; 
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
              
              this.context.moveTo(Start_PosX + iCellDateWidth + iCellShipWidth, Start_PosY + iCellHeight);
              this.context.lineTo(Start_PosX + iCellDateWidth + iCellShipWidth + iCellTimeWidth, Start_PosY + iCellHeight);
              
              str = "From";
              rect_left = Start_PosX + iCellDateWidth + iCellShipWidth +  Math.ceil(iCellTimeWidth/4) ;
              rect_top  = Start_PosY + iCellHeight; 
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1");  
              
              this.context.moveTo(Start_PosX + iCellDateWidth + iCellShipWidth + ifromWidth, Start_PosY + iCellHeight ); //from
              this.context.lineTo(Start_PosX + iCellDateWidth + iCellShipWidth + ifromWidth, Start_PosY + iCellHeight * 2);
            
              str = "To";
              rect_left = Start_PosX + iCellDateWidth + iCellShipWidth +  ifromWidth + 25 ;
              rect_top  = Start_PosY + iCellHeight; 
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
              
              this.context.moveTo(Start_PosX + iCellDateWidth + iCellShipWidth + iCellTimeWidth, Start_PosY); //to
              this.context.lineTo(Start_PosX + iCellDateWidth + iCellShipWidth + iCellTimeWidth, Start_PosY + iCellHeight * 2);	
            
              str = "Content";
              rect_left = Start_PosX + iCellDateWidth + iCellShipWidth + iCellTimeWidth + Math.ceil(iCellContentWidth/2) ;//iCellContentWidth
              rect_top  = Start_PosY + 10 ; 
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
              
              this.context.moveTo(Start_PosX + iWidth, Start_PosY); //Content
              this.context.lineTo(Start_PosX + iWidth, Start_PosY + iCellHeight * 2);
              //this.context.stroke() ;
              
              i = 0;
              iCellHeight = 20 ;
              Start_PosY = Start_PosY + 40; 
              
              this.context.strokeStyle = "black";
              this.context.lineWidth  = 0.5 ;
              
              for(i=0 ; i < res.list.length ; i++) {
                    
                let movingSCH = {};
                  
                //WK_DATE,SER,SHIP,F_TIME,T_TIME,REMARKS
                      
                movingSCH.wkdate 	= res.list[i].wkdate;
                movingSCH.ser 		= res.list[i].ser;
                movingSCH.ship 		= res.list[i].ship;
                movingSCH.ftime 	= res.list[i].ftime;  
                movingSCH.ttime 	= res.list[i].ttime;
                movingSCH.remarks 	= res.list[i].remarks;
                //strWeek = dTemp.GetWeekDay(Func.StoI(strWK));
                
                rect_left = Start_PosX + Math.ceil(iCellDateWidth/2);
                rect_top  = Start_PosY +  iCellHeight * i ; 
                
                //alert(MovingSCH.WK_DATE) ;
                
                if(movingSCH.wkdate != strOld_date)
                {
                  
                  // var strWK = movingSCH.wkdate; //Moving date
                  str = movingSCH.wkdate; //Moving date strWK.substr(4, 2) + "/" + strWK.substr(6, 2) ;
            
                  if(str === null) str = "" ; 
                  this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
                  
                  if( i != 0)
                  {
                    this.context.moveTo(Start_PosX, rect_top);
                    this.context.lineTo(Start_PosX + iCellDateWidth, rect_top);
                  }
                }
                
                this.context.moveTo(Start_PosX, rect_top); //Date
                this.context.lineTo(Start_PosX, rect_top + iCellHeight);
                
                this.context.moveTo(Start_PosX + iCellDateWidth, rect_top); //Date left line
                this.context.lineTo(Start_PosX + iCellDateWidth, rect_top + iCellHeight);
              
                str = movingSCH.ship ; //Ship no
                if(str === null) str = "" ;
                rect_left = Start_PosX + iCellDateWidth + Math.ceil(iCellShipWidth/2) ;
                rect_top  = Start_PosY + iCellHeight * i ; 
                this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
              
                this.context.moveTo(Start_PosX + iCellDateWidth + iCellShipWidth, rect_top ); //Ship
                this.context.lineTo(Start_PosX + iCellDateWidth + iCellShipWidth, rect_top + iCellHeight);
                
                str = movingSCH.ftime ; // From time
                if(str === null) str = "" ;
                rect_left = Start_PosX + iCellDateWidth + iCellShipWidth +  Math.ceil(iCellTimeWidth/4) ;
                rect_top  = Start_PosY + iCellHeight * i; 
                this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
                
                this.context.moveTo(Start_PosX + iCellDateWidth + iCellShipWidth + ifromWidth, rect_top); //from
                this.context.lineTo(Start_PosX + iCellDateWidth + iCellShipWidth + ifromWidth, rect_top + iCellHeight);
              
                str = movingSCH.ttime ; // To time
                if(str === null) str = "" ;
                rect_left = Start_PosX + iCellDateWidth + iCellShipWidth +  ifromWidth + 25 ;
                rect_top  = Start_PosY + iCellHeight * i; 
                this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
                
                this.context.moveTo(Start_PosX + iCellDateWidth + iCellShipWidth + iCellTimeWidth, rect_top); //to
                this.context.lineTo(Start_PosX + iCellDateWidth + iCellShipWidth + iCellTimeWidth, rect_top + iCellHeight);	
              
                str = movingSCH.remarks ; // Content
                rect_left = Start_PosX + iCellDateWidth + iCellShipWidth + iCellTimeWidth ;
                rect_top  = Start_PosY + iCellHeight * i;  
                this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "0"); 
                
                this.context.moveTo(Start_PosX + iWidth, rect_top); //Content
                this.context.lineTo(Start_PosX + iWidth, rect_top + iCellHeight);
                
                this.context.moveTo(Start_PosX + iCellDateWidth, rect_top + iCellHeight); //Each row bottom line
                this.context.lineTo(Start_PosX + iWidth, rect_top + iCellHeight);
            
                strOld_date = movingSCH.wkdate ;
              
              } // end for loop;
              
              this.context.moveTo(Start_PosX, Start_PosY  + iCellHeight * i);
              this.context.lineTo(Start_PosX + iCellDateWidth, Start_PosY  + iCellHeight * i);
              this.context.stroke() ;
              this.context.closePath();
            }  
      }) 
      this.context.restore() ;
    },
    drawMatShipInfo() {// material Ship Information
      // console.log("Drawing material ship info...");
      //	DRAW CURRENT MATERIAL SHIP
      let Start_PosX, Start_PosY;
      let iWidth, iCellSWidth, iCellAWidth, iCellDWidth, iCellQWidth;
      let rect_top, rect_left ;
      let i = 0 ;
      let iCellHeight, str;
      var strOld_div ;

      let params = {strStartDate: this.selectedDate,      }         
      this.context.save();	

      getMatShipList(params)
        .then(res => {  
          // console.log("Drawing moving schedule...", res.list); 
          if (res.list.length > 0){
           
            this.context.strokeStyle = "black";
            this.context.lineWidth  = 1 ;
            this.context.fillStyle = "#d4ecf8" ;
            
            Start_PosX = this.M1_Start_x + 186 ;//265
            Start_PosY = this.Start_Y + CZ(10);//CZ(25);

            iCellSWidth = 120; // SHIP NAME
            iCellAWidth = 50;  // ETA -ETD- SHIPNO
            iCellDWidth = 80; // DIVISION
            iCellQWidth = 70;  // QUAY-CONTENT
          
            iWidth			= iCellSWidth + iCellAWidth*3 + iCellDWidth + iCellQWidth*2;//490;
            iCellHeight		= 20;
          
            this.context.beginPath() ;
            this.context.rect(Start_PosX, Start_PosY, iWidth, iCellHeight*2);
            this.context.fill();
            //Top line
            this.context.moveTo(Start_PosX, Start_PosY);
            this.context.lineTo(Start_PosX + iWidth, Start_PosY); 
            //Bottom line
            this.context.moveTo(Start_PosX, Start_PosY + iCellHeight*2);
            this.context.lineTo(Start_PosX + iWidth, Start_PosY + iCellHeight*2); 
            //Hor line Start
            this.context.moveTo(Start_PosX, Start_PosY);
            this.context.lineTo(Start_PosX, Start_PosY + iCellHeight*2);
            //Hor line Next(2nd)
            // this.context.moveTo(Start_PosX + 40, Start_PosY);
            // this.context.lineTo(Start_PosX + 40, Start_PosY + iCellHeight);
             //Hor line End
            this.context.moveTo(Start_PosX + iWidth, Start_PosY); 
            this.context.lineTo(Start_PosX + iWidth, Start_PosY + iCellHeight*2);
            //Mid line
            this.context.moveTo(Start_PosX, Start_PosY + iCellHeight); 
            this.context.lineTo(Start_PosX + iWidth, Start_PosY + iCellHeight);
                                  
            str = "MATERIAL ABD NIX SHIP INFORMATION";
            rect_left = Start_PosX + Math.ceil((iWidth) /2) ;
            rect_top  = Start_PosY ;
            this.drawText(str, rect_left, rect_top, "m_fntSCH", "black", "1"); 
      
            str = "DIV.";
            rect_left = Start_PosX + Math.ceil(iCellDWidth/2) ;
            rect_top  = Start_PosY + iCellHeight;//10
            this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 

            this.context.moveTo(Start_PosX + iCellDWidth, Start_PosY + iCellHeight);
            this.context.lineTo(Start_PosX + iCellDWidth, Start_PosY + iCellHeight*2);

            str = "Ship No.";
            rect_left = Start_PosX + iCellDWidth + Math.ceil(iCellAWidth/2) ;
            rect_top  = Start_PosY + iCellHeight;
            this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 

            this.context.moveTo(Start_PosX + iCellDWidth + iCellAWidth, Start_PosY + iCellHeight);
            this.context.lineTo(Start_PosX + iCellDWidth + iCellAWidth, Start_PosY + iCellHeight*2);
            
            str = "Content";
            rect_left = Start_PosX + iCellDWidth + iCellAWidth + Math.ceil(iCellQWidth/2) ;
            rect_top  = Start_PosY + iCellHeight;
            this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
          
            this.context.moveTo(Start_PosX + iCellDWidth + iCellAWidth + iCellQWidth, Start_PosY + iCellHeight);
            this.context.lineTo(Start_PosX + iCellDWidth + iCellAWidth + iCellQWidth, Start_PosY + iCellHeight*2);

            str = "Ship Name";
            rect_left = Start_PosX + iCellDWidth + iCellAWidth + iCellQWidth + Math.ceil(iCellSWidth/2) ;
            rect_top  = Start_PosY + iCellHeight;
            this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
          
            this.context.moveTo(Start_PosX + iCellDWidth + iCellAWidth + iCellQWidth + iCellSWidth, Start_PosY + iCellHeight);
            this.context.lineTo(Start_PosX + iCellDWidth + iCellAWidth + iCellQWidth + iCellSWidth, Start_PosY + iCellHeight*2);

            str = "ETA";
            rect_left = Start_PosX + iCellDWidth + iCellAWidth + iCellQWidth + iCellSWidth + Math.ceil(iCellAWidth/2) ;
            rect_top  = Start_PosY + iCellHeight;
            this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
          
            this.context.moveTo(Start_PosX + iCellDWidth + iCellAWidth*2 + iCellQWidth + iCellSWidth, Start_PosY + iCellHeight);
            this.context.lineTo(Start_PosX + iCellDWidth + iCellAWidth*2 + iCellQWidth + iCellSWidth, Start_PosY + iCellHeight*2);
          
            str = "ETD";
            rect_left = Start_PosX + iCellDWidth + iCellAWidth*2 + iCellQWidth + iCellSWidth + Math.ceil(iCellAWidth/2) ;
            rect_top  = Start_PosY + iCellHeight;
            this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
          
            this.context.moveTo(Start_PosX + iCellDWidth + iCellAWidth*3 + iCellQWidth + iCellSWidth, Start_PosY + iCellHeight);
            this.context.lineTo(Start_PosX + iCellDWidth + iCellAWidth*3 + iCellQWidth + iCellSWidth, Start_PosY + iCellHeight*2);
          
            str = "Berthing";
            rect_left = Start_PosX + iCellDWidth + iCellAWidth*3 + iCellQWidth + iCellSWidth + Math.ceil(iCellQWidth/2) ;
            rect_top  = Start_PosY + iCellHeight;
            this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
            
            Start_PosY  = Start_PosY + 40 ;
            // iCellHeight = 18;
            
            for(i= 0; i < res.list.length ; i++) {
            
              let matShipInfo = {};
                  
              //SHIPDIV, SHIPNO, CONTENT, SHIP_NM, ETA, ETD, DIV, LOC
                
              matShipInfo.shipdiv = res.list[i].shipdiv;
              matShipInfo.shipno  = res.list[i].shipno;
              matShipInfo.content = res.list[i].content;
              matShipInfo.shipnm 	= res.list[i].shipnm;
              matShipInfo.eta 		= res.list[i].eta;
              matShipInfo.etd 		= res.list[i].etd; 
              matShipInfo.loc 		= res.list[i].loc;

              rect_left = Start_PosX + Math.ceil(iCellDWidth/2);
              rect_top  = Start_PosY + iCellHeight * i;
             

              if (matShipInfo.shipdiv != strOld_div){
                str = matShipInfo.shipdiv ; // Ship Division 
                if(str === null) str = "" ;              
                this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
                if( i != 0)
                {
                  this.context.moveTo(Start_PosX, rect_top);
                  this.context.lineTo(Start_PosX + iCellDWidth, rect_top);
                }
              }
              this.context.moveTo(Start_PosX,  rect_top); //left line
              this.context.lineTo(Start_PosX, rect_top + iCellHeight); 
               
              this.context.moveTo(Start_PosX + iCellDWidth, rect_top); // div right line
              this.context.lineTo(Start_PosX + iCellDWidth, rect_top + iCellHeight);

              str = matShipInfo.shipno ; // Ship No
              if(str === null) str = "" ;
              rect_left = Start_PosX + iCellDWidth + Math.ceil(iCellAWidth/2);
              rect_top  = Start_PosY + iCellHeight * i;
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1");               
              this.context.moveTo(Start_PosX + iCellDWidth + iCellAWidth, rect_top); // div right line
              this.context.lineTo(Start_PosX + iCellDWidth + iCellAWidth, rect_top + iCellHeight);
              
              str = matShipInfo.content ; // Content
              if(str === null) str = "" ;
              rect_left = Start_PosX + iCellDWidth + iCellAWidth + Math.ceil(iCellQWidth/2);
              rect_top  = Start_PosY + iCellHeight * i;
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1");               
              this.context.moveTo(Start_PosX + iCellDWidth + iCellAWidth + iCellQWidth, rect_top); // div right line
              this.context.lineTo(Start_PosX + iCellDWidth + iCellAWidth + iCellQWidth, rect_top + iCellHeight);

              str = matShipInfo.shipnm ; // Ship Name
              if(str === null) str = "" ;
              rect_left = Start_PosX + iCellDWidth + iCellAWidth + iCellQWidth + Math.ceil(iCellSWidth/2);
              rect_top  = Start_PosY + iCellHeight * i;
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1");               
              this.context.moveTo(Start_PosX + iCellDWidth + iCellAWidth + iCellQWidth + iCellSWidth, rect_top); // div right line
              this.context.lineTo(Start_PosX + iCellDWidth + iCellAWidth + iCellQWidth + iCellSWidth, rect_top + iCellHeight);
            
              str = matShipInfo.eta ; // ETA
              if(str === null) str = "" ;
              rect_left = Start_PosX + iCellDWidth + iCellAWidth + iCellQWidth + iCellSWidth + Math.ceil(iCellAWidth/2);
              rect_top  = Start_PosY + iCellHeight * i;
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1");               
              this.context.moveTo(Start_PosX + iCellDWidth + iCellAWidth*2 + iCellQWidth + iCellSWidth, rect_top); // div right line
              this.context.lineTo(Start_PosX + iCellDWidth + iCellAWidth*2 + iCellQWidth + iCellSWidth, rect_top + iCellHeight);
              
              str = matShipInfo.etd ; // ETD
              if(str === null) str = "" ;
              rect_left = Start_PosX + iCellDWidth + iCellAWidth*2 + iCellQWidth + iCellSWidth + Math.ceil(iCellAWidth/2);
              rect_top  = Start_PosY + iCellHeight * i;
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
              this.context.moveTo(Start_PosX + iCellDWidth + iCellAWidth*3 + iCellQWidth + iCellSWidth, rect_top);//each hor prev line
              this.context.lineTo(Start_PosX + iCellDWidth + iCellAWidth*3 + iCellQWidth + iCellSWidth, rect_top + iCellHeight);
    
              str = matShipInfo.loc ; // LOC
              if(str === null) str = "" ;
              rect_left = Start_PosX + iCellDWidth + iCellAWidth*3 + iCellQWidth + iCellSWidth + Math.ceil(iCellQWidth/2) ;//Start_PosX + 40 + iCellSWidth + iCellAWidth + iCellDWidth + Math.ceil(iCellQWidth/2) ;
              rect_top  = Start_PosY + iCellHeight * i;
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1");              

              this.context.moveTo(Start_PosX + iCellDWidth + iCellAWidth*3 + iCellQWidth*2 + iCellSWidth, rect_top);//each hor end line
              this.context.lineTo(Start_PosX + iCellDWidth + iCellAWidth*3 + iCellQWidth*2 + iCellSWidth, rect_top + iCellHeight);
              
              this.context.moveTo(Start_PosX + iCellDWidth,  rect_top + iCellHeight ); //each row bottom line
              this.context.lineTo(Start_PosX + iCellDWidth + iCellAWidth*3 + iCellQWidth*2 + iCellSWidth, rect_top + iCellHeight);
              
              strOld_div = matShipInfo.shipdiv ;
            } // end for loop
            
            this.context.moveTo(Start_PosX, Start_PosY  + iCellHeight * i);
						this.context.lineTo(Start_PosX + iCellDWidth, Start_PosY  + iCellHeight * i);
            this.context.stroke() ;
            this.context.closePath();
            
          } // end if length > 0
        }); // end getMoveSch        
        this.context.restore();
    },
    drawLayUpInfo() {
      // console.log("Drawing lay-up info...");
      let Start_PosX, Start_PosY;
      let iWidth, iCellDockWidth, iCellBatchWidth, iCellTimeWidth, iCellWidth;
      let rect_top, rect_left ;
      let i = 0 ;
      let iCellHeight, str;      
      let params = {strStartDate: this.selectedDate,      } 
      
      this.context.save();
      getLayUpEvt(params)
        .then(res => {  
          // console.log("Drawing moving schedule...", res.list); 
            if (res.list.length > 0){  

              this.context.strokeStyle = "black";
              this.context.lineWidth  = 0.5 ;
              this.context.fillStyle = "lightgray" ;
              
              //Start_PosX   = M1_Start_x + 5;
              Start_PosX   = 10;
              Start_PosY   = CZ(25);
            
              iCellDockWidth	= 40;
              iCellTimeWidth	= 40;
              iCellBatchWidth	= 120;
              iWidth			= iCellDockWidth + iCellTimeWidth + iCellBatchWidth;
              iCellHeight		= 35;
            
              this.context.beginPath() ;
              this.context.rect(Start_PosX, Start_PosY, iWidth, iCellHeight);
              this.context.fill();
      
              this.context.moveTo(Start_PosX		   , Start_PosY);
              this.context.lineTo(Start_PosX + iWidth, Start_PosY); 
            
              this.context.moveTo(Start_PosX		  , Start_PosY + iCellHeight);
              this.context.lineTo(Start_PosX + iWidth, Start_PosY + iCellHeight); 
            
              this.context.moveTo(Start_PosX, Start_PosY);
              this.context.lineTo(Start_PosX, Start_PosY + iCellHeight);
            
              this.context.moveTo(Start_PosX + iCellDockWidth, Start_PosY);
              this.context.lineTo(Start_PosX + iCellDockWidth, Start_PosY + iCellHeight);
            
              this.context.moveTo(Start_PosX + iCellDockWidth + iCellTimeWidth, Start_PosY);
              this.context.lineTo(Start_PosX + iCellDockWidth + iCellTimeWidth, Start_PosY + iCellHeight);
            
              this.context.moveTo(Start_PosX + iWidth, Start_PosY); 
              this.context.lineTo(Start_PosX + iWidth, Start_PosY + iCellHeight) ;
            
              str = "Ship";
              rect_left = Start_PosX + Math.ceil(iCellDockWidth/2);
              rect_top  = Start_PosY + 10;
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1");

              str = "Time";
              rect_left = Start_PosX + iCellDockWidth + Math.ceil(iCellTimeWidth/2);
              rect_top  = Start_PosY + 10;
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1"); 
              
              str = "Lay-Up";
              rect_left = Start_PosX + iCellDockWidth + iCellTimeWidth + Math.ceil(iCellBatchWidth/2);
              rect_top  = Start_PosY + 10;
              this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1");
              
              iCellHeight = 18 ;
              Start_PosY = Start_PosY + 35; 
              
              for(i= 0; i < res.list.length ; i++) {
              
                let layUpInfo = {};
                    
                //SHIP_NO, LAYUP_SEQ, DESCRIPT
                  
                layUpInfo.shipno 		= res.list[i].shipno;
                layUpInfo.layupseq 	= res.list[i].layupseq;
                layUpInfo.descript 	= res.list[i].descript;
                
                str = layUpInfo.shipno;
                if(str === null) str = "" ;
                rect_left = Start_PosX + Math.ceil(iCellDockWidth/2);
                rect_top  = Start_PosY + i * iCellHeight;
                this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1");
                
                this.context.moveTo(Start_PosX,  rect_top); //left line
                this.context.lineTo(Start_PosX, rect_top + iCellHeight);
                
                this.context.moveTo(Start_PosX + iCellDockWidth, rect_top); // ship right line
                this.context.lineTo(Start_PosX + iCellDockWidth, rect_top + iCellHeight);
          
                str = layUpInfo.layupseq;
                if(str === null) str = "" ;
                rect_left = Start_PosX + iCellDockWidth + Math.ceil(iCellTimeWidth/2);
                rect_top  = Start_PosY + i * iCellHeight;
                this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "1");
                
                this.context.moveTo(Start_PosX + iCellDockWidth + iCellTimeWidth, rect_top); // times right line
                this.context.lineTo(Start_PosX + iCellDockWidth + iCellTimeWidth, rect_top + iCellHeight);
                
                str = layUpInfo.descript; 
                if(str === null) str = "" ;
                rect_left = Start_PosX + iCellDockWidth + iCellTimeWidth + 2;
                rect_top  = Start_PosY + i * iCellHeight;
                this.drawText(str, rect_left, rect_top, "m_fntweather", "black", "0");
                
                this.context.moveTo(Start_PosX + iCellDockWidth + iCellTimeWidth + iCellBatchWidth, rect_top); // layup right line
                this.context.lineTo(Start_PosX + iCellDockWidth + iCellTimeWidth + iCellBatchWidth, rect_top + iCellHeight);
                
                this.context.moveTo(Start_PosX , rect_top + iCellHeight); //each row bottom line
                this.context.lineTo(Start_PosX + iCellDockWidth + iCellTimeWidth + iCellBatchWidth, rect_top + iCellHeight);
                
              } // end for loop
            
              this.context.stroke() ;
              this.context.closePath();
            }; //end if
        }) ; //end getLayUpEvt   
        this.context.restore();
    },
    drawAddObj() {
      // console.log("Drawing additional objects...");
      let rect_left, rect_top ;
      let rect_width, rect_height ;      
      let params = {strStartDate: this.selectedDate,      } 
        
        //this.context.save();
        getAddObj(params)
          .then(res => {  
            // console.log("Drawing additional objects...", res.list); 
            if (res.list.length > 0){  
          
            //	WK_DATE,S_TYPE,OBJECT,SER,OBJ_SX,OBJ_SY,OBJ_EX,
            //  OBJ_EY,STR,F_HEIGHT,F_WIDTH,F_WEIGHT,F_ITALIC,F_UNDERLINE,
            //  F_STRIKEOUT,F_FACENAME,STR_COLOR_R,STR_COLOR_G,STR_COLOR_B,
            //  TRANSPARENT,D_COLOR_OUT_R,D_COLOR_OUT_G,D_COLOR_OUT_B,
            //  D_COLOR_IN_R,D_COLOR_IN_G,D_COLOR_IN_B,LINE_SIZE,
            //  LINE_STYLE,LINE_ARROW
              
            for(let i = 0 ; i < res.list.length ; i++){
          
              let strTextStyle = "" ;
              let Add_Obj = {};
              let strText;
              
              Add_Obj.stype = res.list[i].stype;
              Add_Obj.objsx = res.list[i].objsx;
              Add_Obj.objsy = res.list[i].objsy;
              Add_Obj.objex = res.list[i].objex;
              Add_Obj.objey = res.list[i].objey;
              Add_Obj.str   = res.list[i].str;
              
              strText = Add_Obj.str.toUpperCase(); 
              
              Add_Obj.strcolorr 	= res.list[i].strcolorr;
              Add_Obj.strcolorg 	= res.list[i].strcolorg;
              Add_Obj.strcolorb   = res.list[i].strcolorb;
              
              Add_Obj.ffacename 	= res.list[i].ffacename;
              Add_Obj.fheifht 	  = res.list[i].fheifht;
              Add_Obj.fwidth 	    = res.list[i].fwidth;
              Add_Obj.fweight 	  = res.list[i].fweight;
              Add_Obj.fitalic 	  = res.list[i].fitalic;
              Add_Obj.funderline  = res.list[i].funderline
              Add_Obj.linesize 	  = res.list[i].linesize;
              
              switch (Add_Obj.fitalic){
                case "1" :
                  strTextStyle = "normal " ;
                  break ;
                  
                case "2" :
                  strTextStyle = "bold " ;
                  break ;
                
                case "3" :
                  strTextStyle = "italic " ;
                  break ;
                    
                default :
                  strTextStyle = "normal " ;
                  break ;
              } 
              
              strTextStyle = "" + strTextStyle + Add_Obj.fweight + "18px " +  Add_Obj.fheifht + " " + Add_Obj.ffacename + ", sans-serif" + "" ;
              
              //this.context.lineWidth = parseInt(Add_Obj.LINE_SIZE);
              this.context.lineWidth = 0.5 ; //parseInt(Add_Obj.LINE_SIZE);
              
              if (strText.search("/TRIAL") > 0 || strText.search("TRIAL") > 0  || strText.search(".TRIAL") > 0) {
              
                rect_top 	= parseInt(Add_Obj.objsy) + this.Start_Y - 100;//Hiển thị Text S/Trial: 03/24 ~ 03/26

              
              } else {
              
                rect_top 	= parseInt(Add_Obj.objsy) ;//Hiển thị Text L/C: 04/08(07:30)
              } ;
              rect_left 	= parseInt(Add_Obj.objsx) + 40 ; //dịch chuyển về hướng bên phải
              rect_width 	= parseInt(Add_Obj.objex) - parseInt(Add_Obj.objsx) ;
              rect_height = parseInt(Add_Obj.objey) - parseInt(Add_Obj.objsy) ;
              
              this.context.rect(rect_left, rect_top, rect_width, rect_height) ;
              this.context.stroke() ;
              
              //this.context.font = strTextStyle ;
              
              this.context.font = "normal 400 13px Arial, sans-serif"; 
              this.context.fillStyle = "black" ; //rgb(parseInt(Add_Obj.STR_COLOR_R), parseInt(Add_Obj.STR_COLOR_G), parseInt(Add_Obj.STR_COLOR_B));
              this.context.textBaseline = 'top';
              this.context.textAlign = 'center';
              
              let text_top = rect_top + 5
              let text_left = rect_left + Math.ceil(rect_width/2) ;
              
              this.drawText(Add_Obj.str, text_left, text_top, "m_fntQuay", "blue", "1")
            //context.fillText(Add_Obj.STR, text_left, text_top);	 							
            }
          }
        });	
    },
    drawDescript(descript, pos_x, pos_y){
        // text	
        pos_x = parseInt(pos_x) + 3.0;
        pos_y = parseInt(pos_y) + 6.0;
        
        this.context.save();
        this.context.fillStyle = "black";									
        this.context.font = "12px";
        this.context.textAlign = 'left';								    
        this.context.textBaseline = 'top';
        this.context.fillText(descript, pos_x, pos_y);
        this.context.restore();    	
                    
    }, //drawDescript Ending
    
    drawDescriptTitle(descript, pos_x, pos_y, length, height){
        pos_x = parseInt(pos_x) + 3.0;
        pos_y = parseInt(pos_y) + 6.0;
        
        this.context.save();
        this.context.fillStyle = "blue";									
        this.context.font = "24px"; //"13px";
        this.context.textAlign = 'left';								    
        this.context.textBaseline = 'top';
        this.context.fillText(descript, pos_x, pos_y);
        this.context.restore()
                        
    },//drawDescriptTitle Ending
    
    drawText(descript, pos_x, pos_y, mfntstyle, fntcolor, mTextAlign){
    
        pos_x = parseInt(pos_x) + 1.0;
        pos_y = parseInt(pos_y) + 4.0;
        
        this.context.save();
        this.context.fillStyle = fntcolor;
        
        switch(mfntstyle){
            case "m_fntmainevent" :  
                this.context.font = "normal 400 16px Arial, sans-serif"; 
                break; 
            case "m_fntdft" :
                this.context.font = "bold 400 11px Arial, sans-serif"; 
                break;         
            case "m_fntweather" :  
                this.context.font = "normal 400 10px Times New Roman, sans-serif"; 
                break; 
            case "m_fntshipdesc" :  
                this.context.font = "normal 400 8px Arial, sans-serif";
                break;
            case "m_fntweather2" :
                this.context.font = "normal 400 12px SimSun, sans-serif"; 
                break; 
            case "m_fntHVS" :
                this.context.font = "bold 700 20px Arial, sans-serif"; 
                break;
            case "m_fntDisTribute" :
                this.context.font = "normal 400 14px SimSun, sans-serif"; 
                break; 
            case "m_fntShipCnt" :
                this.context.font = "normal 400 10px SimSun, sans-serif"; 
                break; 
            case "m_fntmainjob" :
                this.context.font = "normal 400 15px Cambria, sans-serif"; 
                break; 
            case "m_fntRemark" :
                this.context.font = "normal 400 12px Arial, sans-serif"; 
                break; 
            case "m_fntQuay" :
                this.context.font = "normal 400 13px Arial, sans-serif"; 
                break; 
            case "m_fntQuayDesc" :
                this.context.font = "normal 400 7px Arial, sans-serif"; 
                break; 
            case "m_fnt_VRemark" :
                this.context.font = "normal 400 11px Vni-Times, sans-serif"; 
                break;
            case "m_fntFlooding" :
                this.context.font = "bold 400 16px SimSun, sans-serif"; 
                break;
            case "m_fntMoving" :
                this.context.font = "normal 400 16px Arial, sans-serif"; 
                break;
            case "m_logFont" :
                this.context.font = "normal 400 12px Calibri, SimSun";   
                break;
            case "m_fntSCH" :
                this.context.font = "normal 400 13px Calibri, SimSun"; 
                break; 
            case "m_fntName" :
                this.context.font = "bold 800 500px Bauhaus 93, sans-serif"; 
                break; 
            case "m_fntName2" :
                this.context.font = "bold 800 300px Bauhaus 93, sans-serif"; 
                break; 
            case "m_fntHead" :
                this.context.font = "bold 800 38px Bauhaus 93, sans-serif"; 
                break;  
            default :
                this.context.font = "normal 400 10px Arial, sans-serif";
                break; 
        } ;
        
        switch(mTextAlign){
            case "0" :
                this.context.textAlign = 'left';	
                break;
                case "1" :
                this.context.textAlign = 'center';
                break ;
                case "2" :
                this.context.textAlign = 'right';
                break ;
            
            default :
                this.context.textAlign = 'left';	
                break;
        }  ; 	
        
        if(mTextAlign == "0") pos_x = pos_x + 2;							    
        this.context.textBaseline = 'top';
        this.context.fillText(descript, pos_x, pos_y);	
        this.context.restore();
                    
    },//drawText Ending
    
    drawRotateText(descript, pos_x, pos_y, mfntstyle, fntcolor, inrot){
        
        //(rotation radius: inrot = 2:90, inrot = 4: 45)
        
        pos_x = parseInt(pos_x) ;
        pos_y = parseInt(pos_y) ;
        
        this.context.save();
        this.context.translate(pos_x, pos_y);
        this.context.rotate(- (parseInt(inrot) * Math.PI) / 180);
        this.context.textAlign = 'center' ;
        this.context.fillStyle = fntcolor;
        
        switch(mfntstyle){
            case "m_fntdft" :
                this.context.font = "bold 400 11px Arial, sans-serif"; 
                break;        
            case "m_fntweather" :  
                this.context.font = "normal 400 10px Times New Roman, sans-serif"; 
                break; 
            case "m_fntshipdesc" :  
                this.context.font = "normal 400 8px Arial, sans-serif";
                break;
            case "m_fntweather2" :
                this.context.font = "normal 400 12px SimSun, sans-serif"; 
                break; 
            case "m_fntHVS" :
                this.context.font = "bold 700 20px Arial, sans-serif"; 
                break;
            case "m_fntDisTribute" :
                this.context.font = "normal 400 14px SimSun, sans-serif"; 
                break; 
            case "m_fntShipCnt" :
                this.context.font = "normal 400 10px SimSun, sans-serif"; 
                break; 
            case "m_fntmainjob" :
                this.context.font = "normal 400 15px Cambria, sans-serif"; 
                break; 
            case "m_fntRemark" :
                this.context.font = "normal 400 12px Arial, sans-serif"; 
                break; 
            case "m_fntQuay" :
                this.context.font = "normal 400 13px Arial, sans-serif"; 
                break; 
            case "m_fntQuayDesc" :
                this.context.font = "normal 400 7px Arial, sans-serif"; 
                break; 
            case "m_fnt_VRemark" :
                this.context.font = "normal 400 11px Vni-Times, sans-serif"; 
                break;
            case "m_fntFlooding" :
                this.context.font = "bold 400 16px SimSun, sans-serif"; 
                break;
            case "m_fntMoving" :
                this.context.font = "bold 400 13px Arial, sans-serif"; 
                break;
            case "m_logFont" :
                this.context.font = "normal 400 12px Calibri, SimSun";   
                break;
            case "m_fntSCH" :
                this.context.font = "normal 400 13px Calibri, SimSun"; 
                break; 
            case "m_fntName" :
                this.context.font = "bold 800 500px Bauhaus 93, sans-serif"; 
                break; 
            case "m_fntName2" :
                this.context.font = "bold 800 300px Bauhaus 93, sans-serif"; 
                break; 
            case "m_fntHead" :
                this.context.font = "bold 800 38px Bauhaus 93, sans-serif"; 
                break;  
            default :
                this.context.font = "normal 400 10px Arial, sans-serif";
                break; 
        } ;
                    
        // context.textBaseline = 'top';
        //fillText('center', 0, lineHeight / 2)
        // var lineHeight = parseInt(context.font.match(/\d+/), 15);
        this.context.fillText(descript, 0, Math.ceil(15/2));					
        this.context.restore();	
                    
    },//drawRotateText Ending

    drawShip(ship){   
      let m_center_x;
      let m_center_y;
      
      let p_x = [];
      let p_y = [];
      let q_x = [];
      let q_y = [];
      let q2_x = [];
      let q2_y = [];	
      let bo_x = [];
      let bo_y = [];
      let px   = {};
        
      let midpos;
      let rad;
      let fact_x, fact_y ;
      let i = 0 ;
      let i_length  	= Math.ceil(parseFloat(ship.loa) + 0.5);
      let i_breadth 	= Math.ceil(parseFloat(ship.breadth) + 0.5);
      let bodybreadth = parseFloat(parseFloat(ship.breadth) / 2);
      let bodylength  = parseFloat(parseFloat(ship.loa) - parseFloat(ship.fc) - parseFloat(ship.ac));
      let sx, sy; //, ex, ey;
      
      //WK_DATE,SHIP_NO,OWNER,SERIES_NO,SHIP_NM,SKIND,LOA,BREADTH,
      //TEL,ETA,CONFIRM,LOC,TEMP_LOC,POS_X,POS_Y, CONT,ALONG,FUTURE,
      //F1,F2,F3,F4,FC,AC,A4,A3,A2,A1,B1
        
      this.context.save();
        
      if(ship.loc === "SS"){ //Sea Trial Ship Now change to "SS"
        
        rad = 0;
        this.iOP_Cnt++ ;
        ship.cont = "P";
        
        sx = parseFloat(this.Q2_Finish_x + 130) ; //120
        sy = this.Start_Y ;//parseFloat(16.0);//12.0
    
        px = CalRotPosXY(parseFloat(this.Q2_Finish_x + 130), sy, sx, sy,rad);//120
    
        m_center_x = parseFloat(px.x) + parseFloat(this.iOP_Cnt * 60);
        m_center_y = parseFloat(px.y) + sy - 15;//Hiển thị vị trí tàu Sea Trial
        
        //sea trial ship with in color
        this.context.fillStyle = "lemonchiffon";//PaleTurquoise
          
      } else if(ship.loc === "Q1"){
        rad = 0;
        if(ship.cont === "S"){
          sx = parseFloat(this.Q1_Start_x) - parseFloat(ship.posx); // - float(ship->m_LOA / 2);
          sy = parseFloat(this.Q1_Start_y) - parseFloat(ship.posy) - parseFloat(0.5);
        }
        else
        {
          sx = parseFloat(this.Q1_Start_x) - parseFloat(ship.posx) - parseFloat(ship.loa);
          sy = parseFloat(this.Q1_Start_y) - parseFloat(ship.posy) - parseFloat(0.5);
        }
        
        m_center_x = parseFloat(sx);
        m_center_y = parseFloat(sy);
    
        //quay Ships color is light yellow
        this.context.fillStyle = "lemonchiffon" ;
        
      }
      else if(ship.loc === "Q2") {
        rad = 0 ;
        if(ship.cont === "S")
        {
          sx = parseFloat(this.Q2_Start_x) - parseFloat(ship.posx) - parseFloat(ship.loa);
          sy = parseFloat(this.Q2_Start_y) + parseFloat(ship.posy) + parseFloat(0.5);
          //alert("Q2 Start: X =" + String(Q2_Start_x) + "/Y = " + String(Q2_Start_y)) ;
    
        }
        else
        {
          sx = parseFloat(this.Q2_Start_x) - parseFloat(ship.posx);// - float(ship->m_LOA / 2);
          sy = parseFloat(this.Q2_Start_y) + parseFloat(ship.posy) + parseFloat(0.5) ;
    
        }
        
        m_center_x = parseFloat(sx);
        m_center_y = parseFloat(sy);
    
        //#1QA, #2QA, #1QB, #2QB quay Ships color is light yellow
        this.context.fillStyle = "lemonchiffon" ;
      }
      else if(ship.loc === "D1"){
        rad = 0;
        if(ship.cont === "P")
        {
          sx = parseFloat(this.D1_Start_x) + parseFloat(ship.posx);// - float(ship->m_LOA / 2);
          sy = parseFloat(this.D1_Start_y) + parseFloat(ship.posy) - parseFloat(0.5) ;
        }
        else
        {
          sx = parseFloat(this.D1_Start_x) + parseFloat(ship.posx) - parseFloat(ship.loa);
          sy = parseFloat(this.D1_Start_y) + parseFloat(ship.posy) + parseFloat(0.5);
        }
        
        m_center_x = parseFloat(sx) ;
        m_center_y = parseFloat(sy) ;
    
        //#1 dock Ships color is light cyan
        this.context.fillStyle = "aquamarine" ;
      }
      else if(ship.loc === "D2"){
        rad = 0;
        if(ship.cont === "P")
        {
          sx = parseFloat(this.D2_Start_x) + parseFloat(ship.posx);// - float(ship->m_LOA / 2);
          sy = parseFloat(this.D2_Start_y) + parseFloat(ship.posy) - parseFloat(0.5) ;
        }
        else
        {
          sx = parseFloat(this.D2_Start_x) + parseFloat(ship.posx) - parseFloat(ship.loa);
          sy = parseFloat(this.D2_Start_y) + parseFloat(ship.posy) + parseFloat(0.5);
    
        }
        
        m_center_x = parseFloat(sx) ;
        m_center_y = parseFloat(sy) ;
    
        //#2 dock Ships color is light cyan
        this.context.fillStyle = "aquamarine" ;
      }
      else if(ship.loc === "Q3"){
        rad = 270;
        if(ship.cont === "P")
        {
          sx = parseFloat(this.Q3_Start_x) - parseFloat(ship.posx) - parseFloat(ship.loa) ;
          sy = parseFloat(this.Q3_Start_y) - parseFloat(ship.posy) - parseFloat(0.5) - 2;
    
        }
        else
        {
          sx = parseFloat(this.Q3_Start_x) - parseFloat(ship.posx) ;// - float(ship->m_LOA / 2);
          sy = parseFloat(this.Q3_Start_y) - parseFloat(ship.posy) - parseFloat(0.5) - 2;
        }
    
        px = CalRotPosXY(parseFloat(this.Q3_Start_x), parseFloat(this.Q3_Start_y), sx, sy, rad);	
          
        m_center_x = parseFloat(px.x);
        m_center_y = parseFloat(px.y);
    
        ///#3QA quay Ships color is light yellow
        this.context.fillStyle = "lemonchiffon" ;
      }
      else if(ship.loc === "M1"){
        rad = 270;
        if(ship.cont === "P")
        {
          sx = parseFloat(this.M1_Start_x) - parseFloat(ship.posx) - parseFloat(ship.loa) ;
          sy = parseFloat(this.M1_Start_y) - parseFloat(ship.posy) - parseFloat(0.5) - 2;
        }
        else
        {
          sx = parseFloat(this.M1_Start_x) - parseFloat(ship.posx) ;// - float(ship->m_LOA / 2);
          sy = parseFloat(this.M1_Start_y) - parseFloat(ship.posy) - parseFloat(0.5) - 2 ;
        }
    
        px = CalRotPosXY(parseFloat(this.M1_Start_x), parseFloat(this.M1_Start_y), sx, sy,rad);
        
        m_center_x = parseFloat(px.x);
        m_center_y = parseFloat(px.y);
        
        this.context.fillStyle = "lemonchiffon" ;
      }    
      else if(ship.loc === "M2"){
        rad = 270;
        if(ship.cont === "P")
        {
          sx = parseFloat(this.M2_Start_x) - parseFloat(ship.posx) - parseFloat(ship.loa);
          sy = parseFloat(this.M2_Start_y) - parseFloat(ship.posy) - parseFloat(0.5) - 2;
        }
        else
        {
          sx = parseFloat(this.M2_Start_x) - parseFloat(ship.posx);  // - float(ship->m_LOA / 2);
          sy = parseFloat(this.M2_Start_y) - parseFloat(ship.posy) - parseFloat(0.5) - 2 ;
    
        }
    
        px = CalRotPosXY(parseFloat(this.M1_Start_x), parseFloat(this.M1_Start_y), sx, sy,rad);
        
        m_center_x = parseFloat(px.x);
        m_center_y = parseFloat(px.y);
    
        this.context.fillStyle = "lemonchiffon" ;
        
      }
      else if(ship.loc === "Q4"){
        rad = 0;
        if(ship.cont === "P")
        {
          sx = parseFloat(this.Q4_Start_x) - parseFloat(ship.posx);// - float(ship->m_LOA / 2);
          sy = parseFloat(this.Q4_Start_y) - parseFloat(ship.posy) - parseFloat(0.5);
        }
        else
        {
          sx = parseFloat(this.Q4_Start_x) - parseFloat(ship.posx) - parseFloat(ship.loa);
          sy = parseFloat(this.Q4_Start_y) - parseFloat(ship.posy) - parseFloat(0.5);
        }
        
        m_center_x = parseFloat(sx);
        m_center_y = parseFloat(sy);
    
        //rad = 0;
        this.context.fillStyle = "lemonchiffon" ;
      }
      else {	
        this.context.restore();
        return ;
      }
      //return; 
        
      let act_x = parseFloat(1.0);
      let act_y = parseFloat(parseFloat(ship.f4)/i_breadth) ;
      
      fact_x = parseFloat(act_x * 5);
      fact_y = parseFloat(act_y * 2);
      
      let headgab = parseFloat(ship.fc)/fact_x ;
      let tailgab = parseFloat(ship.ac)/fact_x ;
    
      let f1 = parseFloat(ship.f1)/fact_y ;
      let f2 = parseFloat(ship.f2)/fact_y ;
      let f3 = parseFloat(ship.f3)/fact_y ;
      let f4 = parseFloat(ship.f4)/fact_y ;
      let a1 = parseFloat(ship.a1)/fact_y ;
      let a2 = parseFloat(ship.a2)/fact_y ;
      let a3 = parseFloat(ship.a3)/fact_y ;
      let a4 = parseFloat(ship.a4)/fact_y ;
      let b1 = parseFloat(ship.b1)/fact_y ; 
  
      if(ship.loc === "Q1" || ship.loc === "Q3" || ship.loc === "M1" || ship.loc === "M2")
      {
        if(ship.cont === "P")
        { 	
          p_x[0] = Math.ceil(m_center_x + headgab * 5 + 0.5);
          p_y[0] = Math.ceil(m_center_y - bodybreadth  + 0.5);
          
          p_x[1] = Math.ceil(m_center_x + headgab * 4 + 0.5);
          p_y[1] = Math.ceil(m_center_y - f4 + 0.5);
          
          p_x[2] = Math.ceil(m_center_x + headgab * 3 + 0.5);
          p_y[2] = Math.ceil(m_center_y - f3 + 0.5);
          
          p_x[3] = Math.ceil(m_center_x + headgab * 2 + 0.5);
          p_y[3] = Math.ceil(m_center_y - f2 + 0.5);
          
          p_x[4] = Math.ceil(m_center_x + headgab + 0.5);
          p_y[4] = Math.ceil(m_center_y - f1 + 0.5);
          
          p_x[5] = Math.ceil(m_center_x + 0.5);
          p_y[5] = Math.ceil(m_center_y - parseFloat(7.0) + 0.5);
          
          p_x[6] = Math.ceil(m_center_x);
          p_y[6] = Math.ceil(m_center_y);
          
          p_x[7] = Math.ceil(m_center_x);
          p_y[7] = Math.ceil(m_center_y + parseFloat(7.0));
          
          p_x[8] = Math.ceil(m_center_x + headgab);
          p_y[8] = Math.ceil(m_center_y + f1);
          
          p_x[9] = Math.ceil(m_center_x + headgab * 2);
          p_y[9] = Math.ceil(m_center_y + f2);
          
          p_x[10] = Math.ceil(m_center_x + headgab * 3);
          p_y[10] = Math.ceil(m_center_y + f3);
          
          p_x[11] = Math.ceil(m_center_x + headgab * 4);
          p_y[11] = Math.ceil(m_center_y + f4);
          
          p_x[12] = Math.ceil(m_center_x + headgab * 5  + 0.5);
          p_y[12] = Math.ceil(m_center_y + bodybreadth - 0.5);
          
          midpos = parseFloat(m_center_x + headgab * 5);
          
          q_x[0] = Math.ceil(midpos + bodylength);
          q_y[0] = Math.ceil(m_center_y + bodybreadth - 0.5);
          
          q_x[1] = Math.ceil(midpos + bodylength + tailgab);
          q_y[1] = Math.ceil(m_center_y + a4);
          
          q_x[2] = Math.ceil(midpos + bodylength + tailgab * 2);
          q_y[2] = Math.ceil(m_center_y + a3);
          
          q_x[3] = Math.ceil(midpos + bodylength + tailgab * 3);
          q_y[3] = Math.ceil(m_center_y + a2);
          
          q_x[4] = Math.ceil(midpos + bodylength + tailgab * 4);
          q_y[4] = Math.ceil(m_center_y + a1);
          
          q_x[5] = Math.ceil(midpos + bodylength + tailgab * 5);
          q_y[5] = Math.ceil(m_center_y + b1);
          
          q2_x[0] = Math.ceil(midpos + bodylength + tailgab * 5);
          q2_y[0] = Math.ceil(m_center_y - b1);
          
          q2_x[1] = Math.ceil(midpos + bodylength + tailgab * 4);
          q2_y[1] = Math.ceil(m_center_y - a1);
          
          q2_x[2] = Math.ceil(midpos + bodylength + tailgab * 3);
          q2_y[2] = Math.ceil(m_center_y - a2);
          
          q2_x[3] = Math.ceil(midpos + bodylength + tailgab * 2);
          q2_y[3] = Math.ceil(m_center_y - a3);
          
          q2_x[4] = Math.ceil(midpos + bodylength + tailgab);
          q2_y[4] = Math.ceil(m_center_y - a4);
          
          q2_x[5] = Math.ceil(midpos + bodylength);
          q2_y[5] = Math.ceil(m_center_y - bodybreadth + 0.5);
    
          for(i=0 ; i<=12; i++){
          
            px = CalRotPosXY(m_center_x, m_center_y, parseFloat(p_x[i]), parseFloat(p_y[i]),rad);
            p_x[i] = CZ(px.x);
            p_y[i] = CZ(px.y);
            
            this.Ship_pt_x[i] = p_x[i];
            this.Ship_pt_y[i] = p_y[i]; 	
          }
          
          for(i=0;i<=5;i++){
          
            px = CalRotPosXY(m_center_x, m_center_y, parseFloat(q_x[i]), parseFloat(q_y[i]),rad);
            q_x[i] = CZ(px.x);
            q_y[i] = CZ(px.y);
                    
            this.Ship_pt_x[13 + i] = q_x[i]; 
            this.Ship_pt_y[13 + i] = q_y[i];
            
          }
          
          for(i=0;i<=5;i++){
            px = CalRotPosXY(m_center_x, m_center_y, parseFloat(q2_x[i]), parseFloat(q2_y[i]),rad);
            q2_x[i] = CZ(px.x);
            q2_y[i] = CZ(px.y);
            
            this.Ship_pt_x[18+i] = q2_x[i];
            this.Ship_pt_y[18+i] = q2_y[i]; 
          }
            
          this.Ship_body_x[0] = m_center_x ;
          this.Ship_body_y[0] = m_center_y ;
            
          this.Ship_body_x[1] = p_x[0] ;
          this.Ship_body_y[1] = p_y[0] ;
            
          this.Ship_body_x[2] = p_x[12] ;
          this.Ship_body_y[2] = p_y[12] ;
            
          this.Ship_body_x[3] = q_x[0] ;
          this.Ship_body_y[3] = q_y[0] ;
            
          this.Ship_body_x[4] = q2_x[5] ;
          this.Ship_body_y[4] = q2_y[5] ;
        
          this.context.beginPath();
          this.context.lineWidth = 1 ;
          this.context.moveTo(p_x[0], p_y[0]) ;
          this.context.bezierCurveTo(p_x[1], p_y[1], p_x[2], p_y[2], p_x[3], p_y[3]);
          this.context.bezierCurveTo(p_x[4], p_y[4], p_x[5], p_y[5], p_x[6], p_y[6]);
          this.context.bezierCurveTo(p_x[7], p_y[7], p_x[8], p_y[8], p_x[9], p_y[9]);
          this.context.bezierCurveTo(p_x[10], p_y[10], p_x[11], p_y[11], p_x[12], p_y[12]);
          
          this.context.lineTo(q_x[0],  q_y[0]) ;
          this.context.bezierCurveTo(q_x[1], q_y[1], q_x[2], q_y[2], q_x[3], q_y[3]);
          this.context.quadraticCurveTo(q_x[4], q_y[4], q_x[5], q_y[5]);
          
          this.context.lineTo(q2_x[0],  q2_y[0]) ;
          this.context.bezierCurveTo(q2_x[1], q2_y[1], q2_x[2], q2_y[2], q2_x[3], q2_y[3]);
          this.context.quadraticCurveTo(q2_x[4], q2_y[4], q2_x[5], q2_y[5]);
          this.context.lineTo(p_x[0], p_y[0]) ;
          this.context.stroke();
          this.context.fill();
          this.context.closePath();
          
        }
        else { //Ship direction = "S"	
                    
          q_x[0] = Math.ceil(m_center_x + tailgab * 5);
          q_y[0] = Math.ceil(m_center_y - bodybreadth  + 0.5);
    
          q_x[1] = Math.ceil(m_center_x + tailgab * 4 );
          q_y[1] = Math.ceil(m_center_y - a4 - 0.5);
          
          q_x[2] = Math.ceil(m_center_x + tailgab * 3);
          q_y[2] = Math.ceil(m_center_y - a3 - 0.5);
          
          q_x[3] = Math.ceil(m_center_x + tailgab * 2 );
          q_y[3] = Math.ceil(m_center_y - a2 - 0.5);
          
          q_x[4] = Math.ceil(m_center_x + tailgab);
          q_y[4] = Math.ceil(m_center_y - a1 - 0.5);
          
          q_x[5] = Math.ceil(m_center_x );
          q_y[5] = Math.ceil(m_center_y - b1 - 0.5);
          
          q2_x[0] = Math.ceil(m_center_x);
          q2_y[0] = Math.ceil(m_center_y + b1 + 0.5);
          
          q2_x[1] = Math.ceil(m_center_x + tailgab);
          q2_y[1] = Math.ceil(m_center_y + a1 + 0.5);
          
          q2_x[2] = Math.ceil(m_center_x + tailgab * 2);
          q2_y[2] = Math.ceil(m_center_y + a2 + 0.5);
          
          q2_x[3] = Math.ceil(m_center_x + tailgab * 3);
          q2_y[3] = Math.ceil(m_center_y + a3 + 0.5);
          
          q2_x[4] = Math.ceil(m_center_x + tailgab * 4);
          q2_y[4] = Math.ceil(m_center_y + a4 + 0.5);
          
          q2_x[5] = Math.ceil(m_center_x + tailgab * 5);
          q2_y[5] = Math.ceil(m_center_y + bodybreadth - 0.5);
          
          midpos = m_center_x + tailgab * 5;
          
          p_x[0] = Math.ceil(m_center_x + tailgab * 5 + bodylength);
          p_y[0] = Math.ceil(m_center_y + bodybreadth - 0.5);
          
          p_x[1] = Math.ceil(m_center_x + tailgab * 5 + bodylength + headgab);
          p_y[1] = Math.ceil(m_center_y + f4);
          
          p_x[2] = Math.ceil(m_center_x + tailgab * 5 + bodylength + headgab * 2);
          p_y[2] = Math.ceil(m_center_y + f3);
          
          p_x[3] = Math.ceil(m_center_x + tailgab * 5 + bodylength + headgab * 3);
          p_y[3] = Math.ceil(m_center_y + f2);
          
          p_x[4] = Math.ceil(m_center_x + tailgab * 5 + bodylength + headgab * 4);
          p_y[4] = Math.ceil(m_center_y + f1);
          
          p_x[5] = Math.ceil(m_center_x + tailgab * 5 + bodylength + headgab * 5);
          p_y[5] = Math.ceil(m_center_y + parseFloat(7.0));
          
          p_x[6] = Math.ceil(m_center_x + tailgab * 5 + bodylength + headgab * 5);
          p_y[6] = Math.ceil(m_center_y);
          
          p_x[7] = Math.ceil(m_center_x + tailgab * 5 + bodylength + headgab * 5);
          p_y[7] = Math.ceil(m_center_y - parseFloat(7.0));
          
          p_x[8] = Math.ceil(m_center_x + tailgab * 5 + bodylength + headgab * 4);
          p_y[8] = Math.ceil(m_center_y - f1);
          
          p_x[9] = Math.ceil(m_center_x + tailgab * 5 + bodylength + headgab * 3);
          p_y[9] = Math.ceil(m_center_y - f2);
          
          p_x[10] = Math.ceil(m_center_x + tailgab * 5 + bodylength + headgab * 2);
          p_y[10] = Math.ceil(m_center_y - f3);
          
          p_x[11] = Math.ceil(m_center_x + tailgab * 5 + bodylength + headgab);
          p_y[11] = Math.ceil(m_center_y - f4);
          
          p_x[12] = Math.ceil(m_center_x + tailgab * 5 + bodylength);
          p_y[12] = Math.ceil(m_center_y - bodybreadth + 0.5);
    
          for(i=0 ; i<=12 ; i++){
          
            px = CalRotPosXY(m_center_x, m_center_y, parseFloat(p_x[i]), parseFloat(p_y[i]),rad);
            
            p_x[i] = CZ(px.x);
            p_y[i] = CZ(px.y);
            
            this.Ship_pt_x[i] = p_x[i];
            this.Ship_pt_y[i] = p_y[i];  
            
          } ;
          
          for(i=0;i<=5;i++){
          
            px = CalRotPosXY(m_center_x, m_center_y, parseFloat(q_x[i]), parseFloat(q_y[i]),rad);
            q_x[i] = CZ(px.x);
            q_y[i] = CZ(px.y);
            this.Ship_pt_x[13+i] = q_x[i];
            this.Ship_pt_y[13+i] = q_y[i]; 
            
          }
          
          for(i=0;i<=5;i++){
            
            px = CalRotPosXY(m_center_x, m_center_y, parseFloat(q2_x[i]), parseFloat(q2_y[i]),rad);
            q2_x[i] = CZ(px.x);
            q2_y[i] = CZ(px.y);
            this.Ship_pt_x[18+i] = q2_x[i];
            this.Ship_pt_y[18+i] = q2_y[i]; 
          }
          
          this.Ship_body_x[0] = m_center_x ;
          this.Ship_body_y[0] = m_center_y ;
            
          this.Ship_body_x[1] = p_x[0] ;
          this.Ship_body_y[1] = p_y[0] ;
            
          this.Ship_body_x[2] = p_x[12] ;
          this.Ship_body_y[2] = p_y[12] ;
            
          this.Ship_body_x[3] = q_x[0] ;
          this.Ship_body_y[3] = q_y[0] ;
            
          this.Ship_body_x[4] = q2_x[5] ;
          this.Ship_body_y[4] = q2_y[5] ;
            
          this.context.beginPath();
          this.context.lineWidth = 1;

          this.context.moveTo(q_x[0],  q_y[0]) ;
          this.context.bezierCurveTo(q_x[1], q_y[1], q_x[2], q_y[2], q_x[3], q_y[3]);
          this.context.quadraticCurveTo(q_x[4], q_y[4], q_x[5], q_y[5]);
          
          this.context.lineTo(q2_x[0],  q2_y[0]) ;
          this.context.bezierCurveTo(q2_x[1], q2_y[1], q2_x[2], q2_y[2], q2_x[3], q2_y[3]);
          this.context.quadraticCurveTo(q2_x[4], q2_y[4], q2_x[5], q2_y[5]);
          
          this.context.lineTo(p_x[0], p_y[0]) ;
          this.context.bezierCurveTo(p_x[1], p_y[1], p_x[2], p_y[2], p_x[3], p_y[3]);
          this.context.bezierCurveTo(p_x[4], p_y[4], p_x[5], p_y[5], p_x[6], p_y[6]);
          this.context.bezierCurveTo(p_x[7], p_y[7], p_x[8], p_y[8], p_x[9], p_y[9]);
          this.context.bezierCurveTo(p_x[10], p_y[10], p_x[11], p_y[11], p_x[12], p_y[12]);

          this.context.lineTo(q_x[0],  q_y[0]) ;
          this.context.stroke();
          this.context.fill();
          this.context.closePath();
          
        }
      }
      else   //dock & quay 2 ships
      {
        if(ship.cont === "S")
        {   
        
          p_x[0] = Math.ceil(m_center_x + headgab * 5 + 0.5);
          p_y[0] = Math.ceil(m_center_y - bodybreadth  + 0.5);
          
          p_x[1] = Math.ceil(m_center_x + headgab * 4 + 0.5);
          p_y[1] = Math.ceil(m_center_y - f4 + 0.5);
          
          p_x[2] = Math.ceil(m_center_x + headgab * 3 + 0.5);
          p_y[2] = Math.ceil(m_center_y - f3 + 0.5);
          
          p_x[3] = Math.ceil(m_center_x + headgab * 2 + 0.5);
          p_y[3] = Math.ceil(m_center_y - f2 + 0.5);
          
          p_x[4] = Math.ceil(m_center_x + headgab + 0.5);
          p_y[4] = Math.ceil(m_center_y - f1 + 0.5);
          
          p_x[5] = Math.ceil(m_center_x + 0.5);
          p_y[5] = Math.ceil(m_center_y - parseFloat(7.0) + 0.5);
          
          p_x[6] = Math.ceil(m_center_x);
          p_y[6] = Math.ceil(m_center_y);
          
          p_x[7] = Math.ceil(m_center_x);
          p_y[7] = Math.ceil(m_center_y + parseFloat(7.0));
          
          p_x[8] = Math.ceil(m_center_x + headgab);
          p_y[8] = Math.ceil(m_center_y + f1);
          
          p_x[9] = Math.ceil(m_center_x + headgab * 2);
          p_y[9] = Math.ceil(m_center_y + f2);
          
          p_x[10] = Math.ceil(m_center_x + headgab * 3);
          p_y[10] = Math.ceil(m_center_y + f3);
          
          p_x[11] = Math.ceil(m_center_x + headgab * 4);
          p_y[11] = Math.ceil(m_center_y + f4);
          
          p_x[12] = Math.ceil(m_center_x + headgab * 5  + 0.5);
          p_y[12] = Math.ceil(m_center_y + bodybreadth - 0.5);
          
          midpos = m_center_x + headgab * 5;
          
          q_x[0] = Math.ceil(midpos + bodylength);
          q_y[0] = Math.ceil(m_center_y + bodybreadth - 0.5);
          
          q_x[1] = Math.ceil(midpos + bodylength + tailgab);
          q_y[1] = Math.ceil(m_center_y + a4);
          
          q_x[2] = Math.ceil(midpos + bodylength + tailgab * 2);
          q_y[2] = Math.ceil(m_center_y + a3);
          
          q_x[3] = Math.ceil(midpos + bodylength + tailgab * 3);
          q_y[3] = Math.ceil(m_center_y + a2);
          
          q_x[4] = Math.ceil(midpos + bodylength + tailgab * 4);
          q_y[4] = Math.ceil(m_center_y + a1);
          
          q_x[5] = Math.ceil(midpos + bodylength + tailgab * 5);
          q_y[5] = Math.ceil(m_center_y + b1);  
                
          q2_x[0] = Math.ceil(midpos + bodylength + tailgab * 5);
          q2_y[0] = Math.ceil(m_center_y - b1);
          
          q2_x[1] = Math.ceil(midpos + bodylength + tailgab * 4);
          q2_y[1] = Math.ceil(m_center_y - a1);
          
          q2_x[2] = Math.ceil(midpos + bodylength + tailgab * 3);
          q2_y[2] = Math.ceil(m_center_y - a2);
          
          q2_x[3] = Math.ceil(midpos + bodylength + tailgab * 2);
          q2_y[3] = Math.ceil(m_center_y - a3);
          
          q2_x[4] = Math.ceil(midpos + bodylength + tailgab);
          q2_y[4] = Math.ceil(m_center_y - a4);
          
          q2_x[5] = Math.ceil(midpos + bodylength);
          q2_y[5] = Math.ceil(m_center_y - bodybreadth + 0.5);
          
          for(i=0;i<=12;i++){
          
            px = CalRotPosXY(m_center_x, m_center_y, parseFloat(p_x[i]), parseFloat(p_y[i]),rad);
            
            p_x[i] = CZ(px.x);
            p_y[i] = CZ(px.y);
            this.Ship_pt_x[i] = p_x[i];
            this.Ship_pt_y[i] = p_y[i];
            
          }
          
          for(i=0;i<=5;i++){
          
            px = CalRotPosXY(m_center_x, m_center_y, parseFloat(q_x[i]), parseFloat(q_y[i]),rad);
            
            q_x[i] = CZ(px.x);
            q_y[i] = CZ(px.y);
            
            this.Ship_pt_x[13+i] = q_x[i];
            this.Ship_pt_y[13+i] = q_y[i];  
          }
          for(i=0;i<=5;i++){
            
            px = CalRotPosXY(m_center_x, m_center_y, parseFloat(q2_x[i]), parseFloat(q2_y[i]),rad);
            
            q2_x[i] = CZ(px.x);
            q2_y[i] = CZ(px.y);
            this.Ship_pt_x[18+i] = q2_x[i];
            this.Ship_pt_y[18+i] = q2_y[i];
            
          }
          
          this.Ship_body_x[0] = m_center_x ;
          this.Ship_body_y[0] = m_center_y ;
            
          this.Ship_body_x[1] = p_x[0] ;
          this.Ship_body_y[1] = p_y[0] ;
            
          this.Ship_body_x[2] = p_x[12] ;
          this.Ship_body_y[2] = p_y[12] ;
            
          this.Ship_body_x[3] = q_x[0] ;
          this.Ship_body_y[3] = q_y[0] ;
            
          this.Ship_body_x[4] = q2_x[5] ;
          this.Ship_body_y[4] = q2_y[5] ;
          
          this.context.beginPath();
          this.context.lineWidth = 1;
          
          this.context.moveTo(p_x[0], p_y[0]);
          this.context.bezierCurveTo(p_x[1], p_y[1], p_x[2], p_y[2], p_x[3], p_y[3]);
          this.context.bezierCurveTo(p_x[4], p_y[4], p_x[5], p_y[5], p_x[6], p_y[6]);
          this.context.bezierCurveTo(p_x[7], p_y[7], p_x[8], p_y[8], p_x[9], p_y[9]);
          this.context.bezierCurveTo(p_x[10], p_y[10], p_x[11], p_y[11], p_x[12], p_y[12]);
          
          this.context.lineTo(q_x[0],  q_y[0]) ;
          this.context.bezierCurveTo(q_x[1], q_y[1], q_x[2], q_y[2], q_x[3], q_y[3]);
          this.context.quadraticCurveTo(q_x[4], q_y[4], q_x[5], q_y[5]);
          this.context.lineTo(q2_x[0],  q2_y[0]) ;
          this.context.bezierCurveTo(q2_x[1], q2_y[1], q2_x[2], q2_y[2], q2_x[3], q2_y[3]);
          this.context.quadraticCurveTo(q2_x[4], q2_y[4], q2_x[5], q2_y[5]);
              
          this.context.lineTo(p_x[0], p_y[0]) ;
          this.context.stroke();
          this.context.fill();
          this.context.closePath();
            
        }
        else{ //ship.cont === "S")
          
          q_x[0] = Math.ceil(m_center_x + tailgab * 5);
          q_y[0] = Math.ceil(m_center_y - bodybreadth  + 0.5);
    
          q_x[1] = Math.ceil(m_center_x + tailgab * 4 );
          q_y[1] = Math.ceil(m_center_y - a4 - 0.5);
          
          q_x[2] = Math.ceil(m_center_x + tailgab * 3);
          q_y[2] = Math.ceil(m_center_y - a3 - 0.5);
          
          q_x[3] = Math.ceil(m_center_x + tailgab * 2 );
          q_y[3] = Math.ceil(m_center_y - a2 - 0.5);
          
          q_x[4] = Math.ceil(m_center_x + tailgab);
          q_y[4] = Math.ceil(m_center_y - a1 - 0.5);
          
          q_x[5] = Math.ceil(m_center_x );
          q_y[5] = Math.ceil(m_center_y - b1 - 0.5);
          
          q2_x[0] = Math.ceil(m_center_x);
          q2_y[0] = Math.ceil(m_center_y + b1 + 0.5);
          
          q2_x[1] = Math.ceil(m_center_x + tailgab);
          q2_y[1] = Math.ceil(m_center_y + a1 + 0.5);
          
          q2_x[2] = Math.ceil(m_center_x + tailgab * 2);
          q2_y[2] = Math.ceil(m_center_y + a2 + 0.5);
          
          q2_x[3] = Math.ceil(m_center_x + tailgab * 3);
          q2_y[3] = Math.ceil(m_center_y + a3 + 0.5);
          
          q2_x[4] = Math.ceil(m_center_x + tailgab * 4);
          q2_y[4] = Math.ceil(m_center_y + a4 + 0.5);
          
          q2_x[5] = Math.ceil(m_center_x + tailgab * 5);
          q2_y[5] = Math.ceil(m_center_y + bodybreadth - 0.5);
          
          midpos = m_center_x + tailgab * 5;
          
          p_x[0] = Math.ceil(m_center_x + tailgab * 5 + bodylength);
          p_y[0] = Math.ceil(m_center_y + bodybreadth - 0.5);
          
          p_x[1] = Math.ceil(m_center_x + tailgab * 5 + bodylength + headgab);
          p_y[1] = Math.ceil(m_center_y + f4);
          
          p_x[2] = Math.ceil(m_center_x + tailgab * 5 + bodylength + headgab * 2);
          p_y[2] = Math.ceil(m_center_y + f3);
          
          p_x[3] = Math.ceil(m_center_x + tailgab * 5 + bodylength + headgab * 3);
          p_y[3] = Math.ceil(m_center_y + f2);
          
          p_x[4] = Math.ceil(m_center_x + tailgab * 5 + bodylength + headgab * 4);
          p_y[4] = Math.ceil(m_center_y + f1);
          
          p_x[5] = Math.ceil(m_center_x + tailgab * 5 + bodylength + headgab * 5);
          p_y[5] = Math.ceil(m_center_y + parseFloat(7.0));
          
          p_x[6] = Math.ceil(m_center_x + tailgab * 5 + bodylength + headgab * 5);
          p_y[6] = Math.ceil(m_center_y);
          
          p_x[7] = Math.ceil(m_center_x + tailgab * 5 + bodylength + headgab * 5);
          p_y[7] = Math.ceil(m_center_y - parseFloat(7.0));
          
          p_x[8] = Math.ceil(m_center_x + tailgab * 5 + bodylength + headgab * 4);
          p_y[8] = Math.ceil(m_center_y - f1);
          
          p_x[9] = Math.ceil(m_center_x + tailgab * 5 + bodylength + headgab * 3);
          p_y[9] = Math.ceil(m_center_y - f2);
          
          p_x[10] = Math.ceil(m_center_x + tailgab * 5 + bodylength + headgab * 2);
          p_y[10] = Math.ceil(m_center_y - f3);
          
          p_x[11] = Math.ceil(m_center_x + tailgab * 5 + bodylength + headgab);
          p_y[11] = Math.ceil(m_center_y - f4);
          
          p_x[12] = Math.ceil(m_center_x + tailgab * 5 + bodylength);
          p_y[12] = Math.ceil(m_center_y - bodybreadth + 0.5);
    
          for(i=0;i<=12;i++){
            px = CalRotPosXY(m_center_x, m_center_y, parseFloat(p_x[i]), parseFloat(p_y[i]),rad);
            
            p_x[i] = CZ(px.x);
            p_y[i] = CZ(px.y);
            
            this.Ship_pt_x[i] = p_x[i];
            this.Ship_pt_y[i] = p_y[i]; 
          }
          
          for(i=0;i<=5;i++){
          
            px = CalRotPosXY(m_center_x, m_center_y, parseFloat(q_x[i]), parseFloat(q_y[i]),rad);
            q_x[i] = CZ(px.x);
            q_y[i] = CZ(px.y);
            this.Ship_pt_x[13+i] = q_x[i];
            this.Ship_pt_y[13+i] = q_y[i]; 
          }
          
          for(i=0;i<=5;i++){
          
            px = CalRotPosXY(m_center_x, m_center_y, parseFloat(q2_x[i]), parseFloat(q2_y[i]),rad);
            q2_x[i] = CZ(px.x);
            q2_y[i] = CZ(px.y);
            this.Ship_pt_x[18+i] = q2_x[i];
            this.Ship_pt_y[18+i] = q2_y[i];
          
          }
          
          this.Ship_body_x[0] = m_center_x ;
          this.Ship_body_y[0] = m_center_y ;
            
          this.Ship_body_x[1] = p_x[0] ;
          this.Ship_body_y[1] = p_y[0] ;
            
          this.Ship_body_x[2] = p_x[12] ;
          this.Ship_body_y[2] = p_y[12] ;
            
          this.Ship_body_x[3] = q_x[0] ;
          this.Ship_body_y[3] = q_y[0] ;
            
          this.Ship_body_x[4] = q2_x[5] ;
          this.Ship_body_y[4] = q2_y[5] ;
        
          this.context.beginPath();
          this.context.lineWidth = 1;
                    
          this.context.moveTo(q_x[0],  q_y[0]) ;
          this.context.bezierCurveTo(q_x[1], q_y[1], q_x[2], q_y[2], q_x[3], q_y[3]);
          this.context.quadraticCurveTo(q_x[4], q_y[4], q_x[5], q_y[5]);
          
          this.context.lineTo(q2_x[0],  q2_y[0]) ;
          this.context.bezierCurveTo(q2_x[1], q2_y[1], q2_x[2], q2_y[2], q2_x[3], q2_y[3]);
          this.context.quadraticCurveTo(q2_x[4], q2_y[4], q2_x[5], q2_y[5]);
          
          this.context.lineTo(p_x[0], p_y[0]) ;
          this.context.bezierCurveTo(p_x[1], p_y[1], p_x[2], p_y[2], p_x[3], p_y[3]);
          this.context.bezierCurveTo(p_x[4], p_y[4], p_x[5], p_y[5], p_x[6], p_y[6]);
          this.context.bezierCurveTo(p_x[7], p_y[7], p_x[8], p_y[8], p_x[9], p_y[9]);
          this.context.bezierCurveTo(p_x[10], p_y[10], p_x[11], p_y[11], p_x[12], p_y[12]);
              
          this.context.lineTo(q_x[0], q_y[0]) ;
          this.context.stroke(); 
          this.context.fill();
          this.context.closePath();
        
        }
      }
      this.context.restore();
    }, // drawShip ending
    ShowShipDesc(ship){
      let rect_left, rect_top ;
      let rad = 0, str ;
        
      //WK_DATE,SHIP_NO,OWNER,SERIES_NO,SHIP_NM,SKIND,LOA,BREADTH,
        //TEL,ETA,CONFIRM,LOC,TEMP_LOC,POS_X,POS_Y, CONT,ALONG,FUTURE,
        //F1,F2,F3,F4,FC,AC,A4,A3,A2,A1,B1
      
      //alert("SHIP BODY: X =" + String(this.Ship_body_x[0]) + "/" + String(this.Ship_body_y[0]) ) ;
      
      this.context.save();
        
      if(ship.loc == "Q1"){
        rad = 0; 
      }
      else if(ship.loc == "Q2"){
        rad = 0;
      }
      else if(ship.loc == "D1"){
        rad = 0;
      }
      else if(ship.loc == "D2"){
        rad = 0;
      }
      else if(ship.loc == "Q3"){
        rad = 90;
      }
      else if(ship.loc == "M1"){
        rad = 90;
      }
      else if(ship.loc == "M2"){
        rad = 90;
      }
      else if(ship.loc == "Q4"){
        rad = 0;
      }
      else if(ship.loc == "SS"){ // Seatrial ship OP <=> SS
        ship.cont = "P";
        rad = 0;
      }
      else {
      }      
      //return;    
      if(ship.loc == "Q3"){
        if(ship.tel == null) {
          str = ship.shipnm;
        }
        else if(ship.tel != "") {
          str = ship.shipnm + "(" + ship.tel + ")";
        } 
        else {
          str = ship.shipnm;
        }
        
        rect_left = this.Ship_body_x[0] - 17 ;
        rect_top  = this.Ship_body_y[0] - Math.ceil(ship.loa/2) ;
          
        this.drawRotateText(str, rect_left , rect_top, "m_fntshipdesc", "darkblue", rad);
        
        if(ship.owner == "")
          str = "";
        else
            str = ship.owner + " #" + ship.seriesno;
    
        rect_left = this.Ship_body_x[0] - 7 ;
        rect_top  = this.Ship_body_y[0] - Math.ceil(ship.loa/2) ;	
        this.drawRotateText(str, rect_left , rect_top, "m_fntshipdesc", "darkblue", rad);
        
        
        str = "(" + String(ship.loa) + " X " + String(ship.BREADTH) + ")";
        
        rect_left = this.Ship_body_x[0] + 3 ;
        rect_top  = this.Ship_body_y[0] - Math.ceil(ship.loa/2) ;	
        this.drawRotateText(str, rect_left , rect_top, "m_fntshipdesc", "darkblue", rad);
        
      }
      else if(ship.loc == "M1" ||  ship.loc == "M2") {
        
        if(ship.tel == null) {
          str = ship.shipnm;
        }
        else if(ship.tel != "") {
          str = ship.shipnm + "(" + ship.tel + ")";
        } 
        else {
          str = ship.shipnm;
        }
        
        rect_left = this.Ship_body_x[0] - 10;
        rect_top  = this.Ship_body_y[0] - Math.ceil(ship.loa/2) ;
        this.drawRotateText(str, rect_left , rect_top, "m_fntshipdesc", "darkblue", rad);
        
        str = "(" + String(ship.loa) + " X " + String(ship.breadth) + ")";
        rect_left = this.Ship_body_x[0] ;
        rect_top  = this.Ship_body_y[0] - Math.ceil(ship.loa/2) ;
        this.drawRotateText(str, rect_left , rect_top, "m_fntshipdesc", "darkblue", rad);
      
      }
      else if( ship.loc == "SS"){ //OP <=> SS
        if(ship.tel == null) {
          str = ship.shipnm;
        }
        else if(ship.tel != "") {
          str = ship.shipnm + "(" + ship.tel + ")";
        } 
        else {
          str = ship.shipnm;
        }
          
        rect_left = this.Ship_body_x[0] + Math.ceil(ship.loa/2) ;
        rect_top  = this.Ship_body_y[0] - 17 ;		
        this.drawText(str, rect_left, rect_top, "m_fntshipdesc", "darkblue", "1");
        
        if(ship.owner == "")
          str = "";
        else
            str = ship.owner + " #" + ship.seriesno;
            
        rect_left = this.Ship_body_x[0] + Math.ceil(ship.loa/2) ;
        rect_top  = this.Ship_body_y[0] - 7;	
        this.drawText(str, rect_left, rect_top, "m_fntshipdesc", "darkblue", "1");  
    
        str = "(" + String(ship.loa) + " X " + String(ship.breadth) + ")";
        rect_left = this.Ship_body_x[0] + Math.ceil(ship.loa/2)  + 4;
        rect_top  = this.Ship_body_y[0] + 3;		
        this.drawText(str, rect_left, rect_top, "m_fntshipdesc", "darkblue", "1"); 
      
      }     
      else if(ship.loc == "D1" || ship.loc == "D2")
      {
        
        if(ship.tel == null) {
          str = ship.shipnm;
        }
        else if(ship.tel != "") {
          str = ship.shipnm + "(" + ship.tel + ")";
        } 
        else {
          str = ship.shipnm;
        }
        rect_left = this.Ship_body_x[0] + Math.ceil(ship.loa/2) ;
        rect_top  = this.Ship_body_y[0] - 17 ;		
        this.drawText(str, rect_left, rect_top, "m_fntshipdesc", "darkblue", "1"); 
    
        if(ship.owner == "")
          str = "";
        else
            str = ship.owner + " #" + ship.seriesno;
            
        rect_left = this.Ship_body_x[0] + Math.ceil(ship.loa/2) ;
        rect_top  = this.Ship_body_y[0] - 7;		
        this.drawText(str, rect_left, rect_top, "m_fntshipdesc", "darkblue", "1"); 
        
        str = "(" + String(ship.loa) + " X " + String(ship.breadth) + ")";
        rect_left = this.Ship_body_x[0] + Math.ceil(ship.loa/2) ;
        rect_top  = this.Ship_body_y[0] + 3 ;		
        this.drawText(str, rect_left, rect_top, "m_fntshipdesc", "darkblue", "1"); 
        
      } 
      else
      {
        if(ship.tel === null) {
          str = ship.shipnm;
        }
        else if(ship.tel != "") {
          str = ship.shipnm + "(" + ship.tel + ")";
        } 
        else {
          str = ship.shipnm;
        }

        if(ship.owner === "" || ship.owner === null){
          rect_left = this.Ship_body_x[0] + Math.ceil(ship.loa/2) ;
          rect_top  = this.Ship_body_y[0] - 10;		
          this.drawText(str, rect_left, rect_top, "m_fntshipdesc", "darkblue", "1"); 
        }  
        else{
            rect_left = this.Ship_body_x[0] + Math.ceil(ship.loa/2) ;
            rect_top  = this.Ship_body_y[0] - 17 ;		
            this.drawText(str, rect_left, rect_top, "m_fntshipdesc", "darkblue", "1"); 
        }
          
        if(ship.owner === "" || ship.owner === null){
          str = "";
          // str = "(" + String(ship.loa) + " X " + String(ship.breadth) + ")";
          rect_left = this.Ship_body_x[0] + Math.ceil(ship.loa/2) ;
          rect_top  = this.Ship_body_y[0] - 1 ;		
          this.drawText( "(" + String(ship.loa) + " X " + String(ship.breadth) + ")", rect_left, rect_top, "m_fntshipdesc", "darkblue", "1"); 
        }  
        else{
            str = ship.owner + " #" + ship.seriesno;
            // str = "(" + String(ship.loa) + " X " + String(ship.breadth) + ")";
            rect_left = this.Ship_body_x[0] + Math.ceil(ship.loa/2) ;
            rect_top  = this.Ship_body_y[0] +  3 ;		
            this.drawText( "(" + String(ship.loa) + " X " + String(ship.breadth) + ")", rect_left, rect_top, "m_fntshipdesc", "darkblue", "1"); 

        }

        rect_left = this.Ship_body_x[0] + Math.ceil(ship.loa/2) ;
        rect_top  = this.Ship_body_y[0] - 7;
        this.drawText(str, rect_left, rect_top, "m_fntshipdesc", "darkblue", "1");   
      } // End if (ship.loc = "Q3")
    
      this.context.restore();
		}, // ShipShipDesc ending 
  }
};
</script>
<style >
  /* Canh giữa cho thanh Bar */
 .loading-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.7); /* Làm mờ nền */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
  }

  /* Canh hiển thị chữ Loading... */
  .loading-text {
    font-size: 18px;
    font-weight: bold;
    color: #1976D2; /* Màu xanh của Vuetify */
    margin-top: 10px;
  }
</style>